const common = {
  mtrBus: {
    en_name: "MTR Feeder Bus",
    tc_name: "港鐵巴士",
  },
  scheduleDep: {
    en_name: "Scheduled",
    tc_name: "預定班次",
  },
  lastUpdate: {
    en_name: "Last Update",
    tc_name: "最後更新",
  },
  npDep: {
    en_name: "No Departures",
    tc_name: "沒有班次",
  },
  noRealTime: {
    en_name: "No real-time info",
    tc_name: "無實時資訊",
  },
  boundFor: {
    en_name: "Bound For ",
    tc_name: "往",
  },
  busRoute: {
    en_name: "MTR Bus Route",
    tc_name: "港鐵巴士路線",
  },
  busRouteShort: {
    en_name: "Route",
    tc_name: "路線",
  },
  title: {
    en_name: "MTR Bus ETA",
    tc_name: "港鐵巴士到站時間",
  },
  BusLReta: {
    en_name: "Light Rail ETA",
    tc_name: "輕鐵班次",
  },
  BusTMLeta: {
    en_name: "Tuen Ma Line ETA",
    tc_name: "屯馬線班次",
  },
  close: {
    en_name: "Close",
    tc_name: "關閉",
  },
  busLoc: {
    en_name: "Bus Current Location",
    tc_name: "巴士實時位置",
  },
  fleetNum: {
    en_name: "Fleet#",
    tc_name: "車隊#",
  },
  plateNum: {
    en_name: "Plate#",
    tc_name: "車牌#",
  },
  model: {
    en_name: "Model",
    tc_name: "車型",
  },
};

const buses = {
  140: {
    plateNo: "RJ7286",
    type: "Enviro 400",
  },
  141: {
    plateNo: "RJ6613",
    type: "Enviro 400",
  },
  142: {
    plateNo: "RN3226",
    type: "Enviro 400",
  },
  143: {
    plateNo: "RN4128",
    type: "Enviro 400",
  },
  144: {
    plateNo: "RP2529",
    type: "Enviro 400",
  },
  145: {
    plateNo: "RP3664",
    type: "Enviro 400",
  },
  146: {
    plateNo: "RP2851",
    type: "Enviro 400",
  },
  147: {
    plateNo: "RP3460",
    type: "Enviro 400",
  },
  148: {
    plateNo: "RP8749",
    type: "Enviro 400",
  },
  149: {
    plateNo: "VN1174",
    type: "Enviro 400",
  },
  150: {
    plateNo: "VN2092",
    type: "Enviro 400",
  },
  319: {
    plateNo: "TX4303",
    type: "Volvo B9TL",
  },
  320: {
    plateNo: "TX6473",
    type: "Volvo B9TL",
  },
  321: {
    plateNo: "TZ4100",
    type: "Volvo B9TL",
  },
  322: {
    plateNo: "TY7838",
    type: "Volvo B9TL",
  },
  323: {
    plateNo: "TZ1572",
    type: "Volvo B9TL",
  },
  324: {
    plateNo: "TZ1884",
    type: "Volvo B9TL",
  },
  325: {
    plateNo: "TZ1574",
    type: "Volvo B9TL",
  },
  326: {
    plateNo: "TY8100",
    type: "Volvo B9TL",
  },
  327: {
    plateNo: "TZ4437",
    type: "Volvo B9TL",
  },
  328: {
    plateNo: "TZ2574",
    type: "Volvo B9TL",
  },
  329: {
    plateNo: "UA6958",
    type: "Volvo B9TL",
  },
  330: {
    plateNo: "UB4596",
    type: "Volvo B9TL",
  },
  331: {
    plateNo: "UB5808",
    type: "Volvo B9TL",
  },
  332: {
    plateNo: "UD5933",
    type: "Volvo B9TL",
  },
  333: {
    plateNo: "UD5100",
    type: "Volvo B9TL",
  },
  334: {
    plateNo: "UF8496",
    type: "Volvo B9TL",
  },
  335: {
    plateNo: "UE8084",
    type: "Volvo B9TL",
  },
  336: {
    plateNo: "UF7737",
    type: "Volvo B9TL",
  },
  337: {
    plateNo: "UF7298",
    type: "Volvo B9TL",
  },
  338: {
    plateNo: "UE8310",
    type: "Volvo B9TL",
  },
  339: {
    plateNo: "UE6714",
    type: "Volvo B9TL",
  },
  340: {
    plateNo: "UG5068",
    type: "Volvo B9TL",
  },
  341: {
    plateNo: "UG5621",
    type: "Volvo B9TL",
  },
  342: {
    plateNo: "UG5808",
    type: "Volvo B9TL",
  },
  343: {
    plateNo: "UJ2647",
    type: "Volvo B9TL",
  },
  344: {
    plateNo: "UH8913",
    type: "Volvo B9TL",
  },
  345: {
    plateNo: "UH9727",
    type: "Volvo B9TL",
  },
  346: {
    plateNo: "UJ4441",
    type: "Volvo B9TL",
  },
  347: {
    plateNo: "UH9756",
    type: "Volvo B9TL",
  },
  348: {
    plateNo: "UH9026",
    type: "Volvo B9TL",
  },
  349: {
    plateNo: "UJ3318",
    type: "Volvo B9TL",
  },
  350: {
    plateNo: "UJ7924",
    type: "Volvo B9TL",
  },
  351: {
    plateNo: "UJ8437",
    type: "Volvo B9TL",
  },
  352: {
    plateNo: "UJ6811",
    type: "Volvo B9TL",
  },
  353: {
    plateNo: "UL2016",
    type: "Volvo B9TL",
  },
  354: {
    plateNo: "UL1305",
    type: "Volvo B9TL",
  },
  355: {
    plateNo: "UL671",
    type: "Volvo B9TL",
  },
  356: {
    plateNo: "UL9577",
    type: "Volvo B9TL",
  },
  357: {
    plateNo: "UL9969",
    type: "Volvo B9TL",
  },
  358: {
    plateNo: "UL8770",
    type: "Volvo B9TL",
  },
  359: {
    plateNo: "UL9538",
    type: "Volvo B9TL",
  },
  360: {
    plateNo: "UM4285",
    type: "Volvo B9TL",
  },
  361: {
    plateNo: "UM2517",
    type: "Volvo B9TL",
  },
  362: {
    plateNo: "UM3660",
    type: "Volvo B9TL",
  },
  363: {
    plateNo: "UM6307",
    type: "Volvo B9TL",
  },
  364: {
    plateNo: "UM6003",
    type: "Volvo B9TL",
  },
  365: {
    plateNo: "UV2460",
    type: "Volvo B9TL",
  },
  366: {
    plateNo: "UP5226",
    type: "Volvo B9TL",
  },
  367: {
    plateNo: "UP5767",
    type: "Volvo B9TL",
  },
  368: {
    plateNo: "UP4987",
    type: "Volvo B9TL",
  },
  369: {
    plateNo: "UR6073",
    type: "Volvo B9TL",
  },
  370: {
    plateNo: "UR6078",
    type: "Volvo B9TL",
  },
  371: {
    plateNo: "UT7522",
    type: "Volvo B9TL",
  },
  372: {
    plateNo: "UT7816",
    type: "Volvo B9TL",
  },
  373: {
    plateNo: "UT7113",
    type: "Volvo B9TL",
  },
  374: {
    plateNo: "UU8713",
    type: "Volvo B9TL",
  },
  375: {
    plateNo: "UU9137",
    type: "Volvo B9TL",
  },
  376: {
    plateNo: "UY5282",
    type: "Volvo B9TL",
  },
  377: {
    plateNo: "UY4870",
    type: "Volvo B9TL",
  },
  378: {
    plateNo: "UY9286",
    type: "Volvo B9TL",
  },
  379: {
    plateNo: "UZ216",
    type: "Volvo B9TL",
  },
  380: {
    plateNo: "VB6400",
    type: "Volvo B9TL",
  },
  381: {
    plateNo: "VB4731",
    type: "Volvo B9TL",
  },
  382: {
    plateNo: "VB6101",
    type: "Volvo B9TL",
  },
  383: {
    plateNo: "VC9776",
    type: "Volvo B9TL",
  },
  384: {
    plateNo: "VD5529",
    type: "Volvo B9TL",
  },
  385: {
    plateNo: "VD6493",
    type: "Volvo B9TL",
  },
  386: {
    plateNo: "VE2956",
    type: "Volvo B9TL",
  },
  504: {
    plateNo: "SE5526",
    type: "Enviro500 MMC",
  },
  505: {
    plateNo: "SE6425",
    type: "Enviro500 MMC",
  },
  506: {
    plateNo: "SE5999",
    type: "Enviro500 MMC",
  },
  507: {
    plateNo: "SE6500",
    type: "Enviro500 MMC",
  },
  508: {
    plateNo: "SE5177",
    type: "Enviro500 MMC",
  },
  509: {
    plateNo: "SE5163",
    type: "Enviro500 MMC",
  },
  510: {
    plateNo: "SS7944",
    type: "Enviro500 MMC",
  },
  511: {
    plateNo: "SS8057",
    type: "Enviro500 MMC",
  },
  512: {
    plateNo: "SS5951",
    type: "Enviro500 MMC",
  },
  513: {
    plateNo: "ST5900",
    type: "Enviro500 MMC",
  },
  514: {
    plateNo: "ST5996",
    type: "Enviro500 MMC",
  },
  515: {
    plateNo: "SX1035",
    type: "Enviro500 MMC",
  },
  516: {
    plateNo: "SX529",
    type: "Enviro500 MMC",
  },
  517: {
    plateNo: "SX2027",
    type: "Enviro500 MMC",
  },
  518: {
    plateNo: "TF8478",
    type: "Enviro500 MMC",
  },
  519: {
    plateNo: "TH4482",
    type: "Enviro500 MMC",
  },
  520: {
    plateNo: "TJ5864",
    type: "Enviro500 MMC",
  },
  521: {
    plateNo: "TK5086",
    type: "Enviro500 MMC",
  },
  522: {
    plateNo: "TP4605",
    type: "Enviro500 MMC",
  },
  523: {
    plateNo: "TP5257",
    type: "Enviro500 MMC",
  },
  524: {
    plateNo: "TP6265",
    type: "Enviro500 MMC",
  },
  525: {
    plateNo: "TS2088",
    type: "Enviro500 MMC",
  },
  526: {
    plateNo: "TS3997",
    type: "Enviro500 MMC",
  },
  527: {
    plateNo: "TS3416",
    type: "Enviro500 MMC",
  },
  528: {
    plateNo: "TS8442",
    type: "Enviro500 MMC",
  },
  529: {
    plateNo: "TT8108",
    type: "Enviro500 MMC",
  },
  530: {
    plateNo: "TT7597",
    type: "Enviro500 MMC",
  },
  531: {
    plateNo: "TV6778",
    type: "Enviro500 MMC",
  },
  532: {
    plateNo: "TV7525",
    type: "Enviro500 MMC",
  },
  533: {
    plateNo: "TV6629",
    type: "Enviro500 MMC",
  },
  534: {
    plateNo: "TV9422",
    type: "Enviro500 MMC",
  },
  535: {
    plateNo: "TV9465",
    type: "Enviro500 MMC",
  },
  536: {
    plateNo: "TW455",
    type: "Enviro500 MMC",
  },
  537: {
    plateNo: "TV9066",
    type: "Enviro500 MMC",
  },
  538: {
    plateNo: "VD6480",
    type: "Enviro500 MMC",
  },
  539: {
    plateNo: "VD5694",
    type: "Enviro500 MMC",
  },
  540: {
    plateNo: "VD5396",
    type: "Enviro500 MMC",
  },
  541: {
    plateNo: "VE3584",
    type: "Enviro500 MMC",
  },
  542: {
    plateNo: "VE4425",
    type: "Enviro500 MMC",
  },
  543: {
    plateNo: "VE2830",
    type: "Enviro500 MMC",
  },
  544: {
    plateNo: "VL5981",
    type: "Enviro500 MMC",
  },
  545: {
    plateNo: "VN2873",
    type: "Enviro500 MMC",
  },
  546: {
    plateNo: "XF3414",
    type: "Enviro500 MMC",
  },
  547: {
    plateNo: "XF2507",
    type: "Enviro500 MMC",
  },
  548: {
    plateNo: "XF4490",
    type: "Enviro500 MMC",
  },
  549: {
    plateNo: "XF2977",
    type: "Enviro500 MMC",
  },
  801: {
    plateNo: "NE5930",
    type: "Enviro500 12m",
  },
  802: {
    plateNo: "NF6585",
    type: "Enviro500 12m",
  },
  803: {
    plateNo: "NF9815",
    type: "Enviro500 12m",
  },
  804: {
    plateNo: "NF9153",
    type: "Enviro500 12m",
  },
  805: {
    plateNo: "NG8400",
    type: "Enviro500 12m",
  },
  806: {
    plateNo: "NG7406",
    type: "Enviro500 12m",
  },
  807: {
    plateNo: "NH776",
    type: "Enviro500 12m",
  },
  808: {
    plateNo: "NH2643",
    type: "Enviro500 12m",
  },
  809: {
    plateNo: "NH2745",
    type: "Enviro500 12m",
  },
  810: {
    plateNo: "NU3439",
    type: "Enviro500 12m",
  },
  811: {
    plateNo: "NU9816",
    type: "Enviro500 12m",
  },
  812: {
    plateNo: "NU8940",
    type: "Enviro500 12m",
  },
  813: {
    plateNo: "NU9852",
    type: "Enviro500 12m",
  },
  814: {
    plateNo: "NU8805",
    type: "Enviro500 12m",
  },
  815: {
    plateNo: "NW1524",
    type: "Enviro500 12m",
  },
  816: {
    plateNo: "NW2333",
    type: "Enviro500 12m",
  },
  817: {
    plateNo: "NW3480",
    type: "Enviro500 12m",
  },
  818: {
    plateNo: "NW6906",
    type: "Enviro500 12m",
  },
  819: {
    plateNo: "NW6826",
    type: "Enviro500 12m",
  },
  820: {
    plateNo: "NW8224",
    type: "Enviro500 12m",
  },
  821: {
    plateNo: "NX3790",
    type: "Enviro500 12m",
  },
  822: {
    plateNo: "NX4438",
    type: "Enviro500 12m",
  },
  823: {
    plateNo: "NX3837",
    type: "Enviro500 12m",
  },
  824: {
    plateNo: "NX8813",
    type: "Enviro500 12m",
  },
  825: {
    plateNo: "RR8145",
    type: "Enviro500 11.3m",
  },
  826: {
    plateNo: "RR7897",
    type: "Enviro500 11.3m",
  },
  827: {
    plateNo: "RT1670",
    type: "Enviro500 11.3m",
  },
  828: {
    plateNo: "RT2217",
    type: "Enviro500 11.3m",
  },
  829: {
    plateNo: "RT1907",
    type: "Enviro500 11.3m",
  },
  830: {
    plateNo: "RU8323",
    type: "Enviro500 11.3m",
  },
  831: {
    plateNo: "RU6727",
    type: "Enviro500 11.3m",
  },
  832: {
    plateNo: "RU6900",
    type: "Enviro500 11.3m",
  },
  833: {
    plateNo: "RU8176",
    type: "Enviro500 11.3m",
  },
  860: {
    plateNo: "YD8329",
    type: "Enviro500 MMC 12m",
  },
  861: {
    plateNo: "YD8109",
    type: "Enviro500 MMC 12m",
  },
  862: {
    plateNo: "YD6939",
    type: "Enviro500 MMC 12m",
  },
  901: {
    plateNo: "NM4716",
    type: "Enviro200 Dart",
  },
  902: {
    plateNo: "NM4760",
    type: "Enviro200 Dart",
  },
  903: {
    plateNo: "NP7825",
    type: "Enviro200 Dart",
  },
  904: {
    plateNo: "NP8088",
    type: "Enviro200 Dart",
  },
  905: {
    plateNo: "NR5800",
    type: "Enviro200 Dart",
  },
  906: {
    plateNo: "NR1096",
    type: "Enviro200 Dart",
  },
  907: {
    plateNo: "NR1633",
    type: "Enviro200 Dart",
  },
  908: {
    plateNo: "NS577",
    type: "Enviro200 Dart",
  },
  909: {
    plateNo: "NT2693",
    type: "Enviro200 Dart",
  },
  910: {
    plateNo: "NS1189",
    type: "Enviro200 Dart",
  },
  911: {
    plateNo: "NS7357",
    type: "Enviro200 Dart",
  },
  Z01: {
    plateNo: "ZF2271",
    type: "Enviro500EV",
  },
  Z02: {
    plateNo: "ZU5915",
    type: "Enviro500EV",
  },
  Z03: {
    plateNo: "ZU8662",
    type: "Enviro500EV",
  },
  Z04: {
    plateNo: "ZV2707",
    type: "Enviro500EV",
  },
  Z05: {
    plateNo: "ZW4440",
    type: "Enviro500EV",
  },
  Z06: {
    plateNo: "ZY6697",
    type: "Enviro500EV",
  },
  Z07: {
    plateNo: "ZY8700",
    type: "Enviro500EV",
  },
  Z08: {
    plateNo: "WA9309",
    type: "Enviro500EV",
  },
  Z09: {
    plateNo: "ZZ5997",
    type: "Enviro500EV",
  },
  Z10: {
    plateNo: "WA9751",
    type: "Enviro500EV",
  },
  Z11: {
    plateNo: "WK2746",
    type: "Enviro500EV",
  },
  Z12: {
    plateNo: "WK2514",
    type: "Enviro500EV",
  },
};

const route = {
  506: {
    en_name: "Tuen Mun Ferry Pier to Siu Lun",
    tc_name: "屯門碼頭至兆麟",
    bound: {
      UP: {
        dest: "CIR",
        stops: [
          "506-U010",
          "506-U020",
          "506-U030",
          "506-U040",
          "506-U050",
          "506-U060",
          "506-U070",
          "506-U080",
          "506-U090",
          "506-U100",
          "506-U110",
          "506-D010",
          "506-D020",
          "506-D030",
          "506-D040",
          "506-D050",
          "506-D060",
          "506-D070",
          "506-D080",
          "506-D090",
          "506-D100",
          "506-D110",
          "506-D120",
          "506-D130",
          "506-U011",
        ],
      },
    },
  },
  K12: {
    en_name: "Tai Po Market Station to Eightland Garden",
    tc_name: "大埔墟站至八號花園",
    bound: {
      UP: {
        dest: "EG",
        stops: ["K12-U010", "K12-U020", "K12-U030"],
      },
      DOWN: {
        dest: "TPMS",
        stops: ["K12-D010", "K12-D020", "K12-D030", "K12-D040"],
      },
    },
  },
  K14: {
    en_name: "Tai Po Mega Mall to Tai Po Market Station",
    tc_name: "大埔超級城至大埔墟站",
    bound: {
      UP: {
        dest: "TPMS",
        stops: ["K14-D010", "K14-D020", "K14-D030"],
      },
    },
  },
  K17: {
    en_name: "Tai Po Market Station to Fu Shin",
    tc_name: "大埔墟站至富善",
    bound: {
      UP: {
        dest: "FS",
        stops: ["K17-U010", "K17-U020", "K17-U030", "K17-U040"],
      },
      DOWN: {
        dest: "TPMS",
        stops: ["K17-D010", "K17-D020", "K17-D030"],
      },
    },
  },
  K18: {
    en_name: "Tai Po Market Station to Kwong Fuk",
    tc_name: "大埔墟站至廣福",
    bound: {
      UP: {
        dest: "KF",
        stops: ["K18-U010", "K18-U020", "K18-U030"],
      },
      DOWN: {
        dest: "TPMS",
        stops: ["K18-D010", "K18-D020", "K18-D030"],
      },
    },
  },
  K51: {
    en_name: "Fu Tai to Tai Lam",
    tc_name: "富泰至大欖",
    bound: {
      UP: {
        dest: "TL",
        stops: [
          "K51-U010",
          "K51-U020",
          "K51-U030",
          "K51-U040",
          "K51-U050",
          "K51-U060",
          "K51-U070",
          "K51-U080",
          "K51-U090",
          "K51-U100",
          "K51-U110",
          "K51-U120",
          "K51-U130",
          "K51-U140",
          "K51-U150",
          "K51-U160",
          "K51-U170",
          "K51-U180",
          "K51-U190",
          "K51-U200",
          "K51-U210",
          "K51-U220",
          "K51-U230",
          "K51-U240",
          "K51-U250",
        ],
      },
      DOWN: {
        dest: "FT",
        stops: [
          "K51-D010",
          "K51-D020",
          "K51-D030",
          "K51-D040",
          "K51-D050",
          "K51-D060",
          "K51-D070",
          "K51-D080",
          "K51-D090",
          "K51-D100",
          "K51-D110",
          "K51-D120",
          "K51-D130",
          "K51-D140",
          "K51-D150",
          "K51-D160",
          "K51-D170",
          "K51-D180",
          "K51-D190",
          "K51-D200",
          "K51-D210",
          "K51-D220",
          "K51-D230",
          "K51-D240",
          "K51-D250",
          "K51-D260",
          "K51-D270",
          "K51-D280",
          "K51-D290",
        ],
      },
    },
  },
  K51A: {
    en_name: "Fu Tai to So Kwun Wat",
    tc_name: "富泰至掃管笏",
    bound: {
      UP: {
        dest: "SKW",
        stops: [
          "K51A-U010",
          "K51A-U020",
          "K51A-U030",
          "K51A-U040",
          "K51A-U050",
          "K51A-U060",
          "K51A-U070",
          "K51A-U080",
          "K51A-U090",
          "K51A-U100",
          "K51A-U110",
          "K51A-U120",
          "K51A-U130",
          "K51A-U140",
          "K51A-U150",
          "K51A-U160",
          "K51A-U170",
          "K51A-U180",
          "K51A-U190",
          "K51A-U200",
          "K51A-U210",
          "K51A-U220",
          "K51A-U230",
          "K51A-U240",
          "K51A-U250",
        ],
      },
      DOWN: {
        dest: "FT",
        stops: [
          "K51A-D010",
          "K51A-D020",
          "K51A-D030",
          "K51A-D040",
          "K51A-D050",
          "K51A-D060",
          "K51A-D070",
          "K51A-D080",
          "K51A-D090",
          "K51A-D100",
          "K51A-D110",
          "K51A-D120",
          "K51A-D140",
          "K51A-D150",
          "K51A-D160",
          "K51A-D170",
          "K51A-D180",
          "K51A-D190",
          "K51A-D200",
          "K51A-D210",
          "K51A-D220",
          "K51A-D230",
          "K51A-D240",
          "K51A-D250",
          "K51A-D260",
          "K51A-D270",
        ],
      },
    },
  },
  K52: {
    en_name: "Yuet Wu Villa to Lung Kwu Tan",
    tc_name: "悅湖山莊至龍鼓灘",
    bound: {
      UP: {
        dest: "LKT",
        stops: [
          "K52-nU010",
          "K52-nU020",
          "K52-nU030",
          "K52-nU040",
          "K52-nU050",
          "K52-nU060",
          "K52-nU070",
          "K52-nU080",
          "K52-nU090",
          "K52-nU100",
          "K52-nU110",
          "K52-nU120",
          "K52-nU130",
          "K52-nU140",
          "K52-nU150",
          "K52-nU160",
          "K52-nU170",
          "K52-nU180",
          "K52-nU190",
          "K52-nU200",
          "K52-nU210",
          "K52-nU220",
          "K52-nU230",
          "K52-nU240",
          "K52-nU250",
          "K52-nU260",
          "K52-nU270",
          "K52-nU280",
          "K52-nU290",
          "K52-nU300",
          "K52-nU310",
        ],
      },
      DOWN: {
        dest: "YWV",
        stops: [
          "K52-nD010",
          "K52-nD020",
          "K52-nD030",
          "K52-nD040",
          "K52-nD050",
          "K52-nD060",
          "K52-nD070",
          "K52-nD080",
          "K52-nD090",
          "K52-nD100",
          "K52-nD110",
          "K52-nD120",
          "K52-nD130",
          "K52-nD140",
          "K52-nD150",
          "K52-nD160",
          "K52-nD170",
          "K52-nD180",
          "K52-nD190",
          "K52-nD200",
          "K52-nD210",
          "K52-nD220",
          "K52-nD230",
          "K52-nD240",
          "K52-nD250",
          "K52-nD260",
          "K52-nD270",
          "K52-nD280",
          "K52-nD290",
          "K52-nD300",
        ],
      },
    },
  },
  K52A: {
    en_name: "Tuen Mun Station to Tsang Tsui",
    tc_name: "屯門站至曾咀",
    bound: {
      UP: {
        dest: "TT",
        stops: [
          "K52A-U010",
          "K52A-U020",
          "K52A-U030",
          "K52A-U040",
          "K52A-U050",
          "K52A-U060",
          "K52A-U070",
          "K52A-U080",
          "K52A-U090",
          "K52A-U100",
          "K52A-U110",
          "K52A-U120",
          "K52A-U130",
          "K52A-U140",
          "K52A-U150",
          "K52A-U160",
          "K52A-U170",
          "K52A-U180",
        ],
      },
      DOWN: {
        dest: "TMS",
        stops: [
          "K52A-D010",
          "K52A-D020",
          "K52A-D030",
          "K52A-D040",
          "K52A-D050",
          "K52A-D060",
          "K52A-D070",
          "K52A-D080",
          "K52A-D090",
          "K52A-D100",
          "K52A-D110",
          "K52A-D120",
          "K52A-D130",
          "K52A-D140",
          "K52A-D150",
          "K52A-D160",
          "K52A-D170",
          "K52A-D180",
          "K52A-D190",
        ],
      },
    },
  },
  K53: {
    en_name: "Tuen Mun Station to So Kwun Wat (Circular)",
    tc_name: "屯門站至掃管笏 (循環綫)",
    bound: {
      UP: {
        dest: "CIR",
        stops: [
          "K53-U010",
          "K53-U020",
          "K53-U030",
          "K53-U040",
          "K53-U050",
          "K53-U060",
          "K53-U070",
          "K53-U080",
          "K53-U090",
          "K53-U100",
          "K53-U110",
          "K53-U120",
          "K53-U130",
          "K53-U140",
          "K53-D010",
          "K53-D015",
          "K53-D020",
          "K53-D030",
          "K53-D040",
          "K53-D050",
          "K53-D060",
          "K53-D070",
          "K53-D080",
          "K53-D090",
          "K53-D100",
          "K53-D110",
          "K53-D120",
          "K53-D130",
          "K53-D140",
          "K53-D150",
          "K53-D160",
          "K53-U011",
        ],
      },
    },
  },
  "K53*": {
    en_name: "Tuen Mun Station to Yip Wong Estate Special Trips (Circular)",
    tc_name: "屯門站至業旺邨 待別班次 (循環線)",
    bound: {
      UP: {
        dest: "CIR",
        stops: [
          "K53*-U010",
          "K53*-U020",
          "K53*-U030",
          "K53*-U040",
        ],
      },
    },
  },
  K54: {
    en_name: "Wo Tin Estate to Tuen Mun Town Centre (Circular)",
    tc_name: "和田邨至屯門市中心 (循環綫)",
    bound: {
      UP: {
        dest: "CIR",
        stops: [
          "K54-U010",
          "K54-U020",
          "K54-U030",
          "K54-U040",
          "K54-U050",
          "K54-U060",
          "K54-U070",
          "K54-D010",
          "K54-D020",
          "K54-D030",
          "K54-D040",
          "K54-D050",
          "K54-D060",
          "K54-D070",
        ],
      },
    },
  },
  K54A: {
    en_name: "Wo Tin Estate to Siu Hong Station",
    tc_name: "和田邨至兆康站",
    bound: {
      UP: {
        dest: "SHS",
        stops: [
          "K54A-U010",
          "K54A-U020",
          "K54A-U030",
          "K54A-U040",
        ],
      },
      DOWN: {
        dest: "WTE",
        stops: [
          "K54A-D010",
          "K54A-D020",
          "K54A-D030",
          "K54A-D040",
        ],
      },
    },
  },
  K58: {
    en_name: "Fu Tai to So Kwun Wat",
    tc_name: "富泰至掃管筍",
    bound: {
      UP: {
        dest: "SKW",
        stops: [
          "K58-U010",
          "K58-U020",
          "K58-U023",
          "K58-U026",
          "K58-U030",
          "K58-U040",
          "K58-U050",
          "K58-U060",
          "K58-U070",
          "K58-U080",
          "K58-U090",
          "K58-U100",
          "K58-U110",
          "K58-U120",
          "K58-U130",
          "K58-U140",
          "K58-U150",
          "K58-U160",
          "K58-U170",
          "K58-U180",
          "K58-U190",
          "K58-U200",
          "K58-U210",
        ],
      },
      DOWN: {
        dest: "FT",
        stops: [
          "K58-D010",
          "K58-D020",
          "K58-D030",
          "K58-D040",
          "K58-D050",
          "K58-D060",
          "K58-D070",
          "K58-D080",
          "K58-D090",
          "K58-D100",
          "K58-D110",
          "K58-D120",
          "K58-D130",
          "K58-D140",
          "K58-D150",
          "K58-D160",
          "K58-D170",
          "K58-D180",
          "K58-D190",
          "K58-D193",
          "K58-D196",
          "K58-D200",
          "K58-D210",
        ],
      },
    },
  },
  K65: {
    en_name: "Yuen Long Station to Lau Fau Shan",
    tc_name: "元朗站至流浮山",
    bound: {
      UP: {
        dest: "LFS",
        stops: [
          "K65-U010",
          "K65-U020",
          "K65-U030",
          "K65-U040",
          "K65-U050",
          "K65-U060",
          "K65-U070",
          "K65-U080",
          "K65-U090",
          "K65-U100",
          "K65-U110",
          "K65-U120",
          "K65-U130",
          "K65-U140",
          "K65-U150",
          "K65-U160",
          "K65-U170",
          "K65-U180",
          "K65-U190",
          "K65-U200",
          "K65-U210",
          "K65-U220",
          "K65-U230",
        ],
      },
      DOWN: {
        dest: "YLS",
        stops: [
          "K65-D010",
          "K65-D020",
          "K65-D030",
          "K65-D040",
          "K65-D050",
          "K65-D060",
          "K65-D070",
          "K65-D080",
          "K65-D090",
          "K65-D100",
          "K65-D110",
          "K65-D120",
          "K65-D130",
          "K65-D140",
          "K65-D150",
          "K65-D160",
          "K65-D170",
          "K65-D180",
          "K65-D190",
        ],
      },
    },
  },
  K65A: {
    en_name: "Tin Shui Wai Station to Lau Fau Shan",
    tc_name: "天水圍站至流浮山",
    bound: {
      UP: {
        dest: "LFS",
        stops: [
          "K65A-U010",
          "K65A-U020",
          "K65A-U030",
          "K65A-U040",
          "K65A-U050",
          "K65A-U060",
          "K65A-U070",
          "K65A-U080",
          "K65A-U090",
          "K65A-U100",
          "K65A-U110",
          "K65A-U120",
          "K65A-U130",
        ],
      },
      DOWN: {
        dest: "TSWS",
        stops: [
          "K65A-D010",
          "K65A-D020",
          "K65A-D030",
          "K65A-D040",
          "K65A-D050",
          "K65A-D060",
          "K65A-D070",
          "K65A-D080",
          "K65A-D090",
          "K65A-D100",
          "K65A-D110",
        ],
      },
    },
  },
  K66: {
    en_name: "Long Ping to Tai Tong Wong Nai Tun Tsuen",
    tc_name: "朗屏至大棠黃泥墩村",
    bound: {
      UP: {
        dest: "TTWNTT",
        stops: [
          "K66-U010",
          "K66-U020",
          "K66-U030",
          "K66-U040",
          "K66-U050",
          "K66-U060",
          "K66-U070",
          "K66-U080",
          "K66-U090",
          "K66-U100",
          "K66-U110",
          "K66-U120",
          "K66-U130",
          "K66-U140",
          "K66-U150",
          "K66-U160",
          "K66-U170",
          "K66-U180",
          "K66-U190",
          "K66-U200",
          "K66-U210",
          "K66-U220",
        ],
      },
      DOWN: {
        dest: "LP",
        stops: [
          "K66-D010",
          "K66-D020",
          "K66-D030",
          "K66-D040",
          "K66-D050",
          "K66-D060",
          "K66-D070",
          "K66-D080",
          "K66-D090",
          "K66-D100",
          "K66-D110",
          "K66-D120",
          "K66-D130",
          "K66-D140",
          "K66-D150",
          "K66-D160",
          "K66-D170",
          "K66-D180",
          "K66-D190",
          "K66-D200",
          "K66-D210",
          "K66-D220",
          "K66-D230",
          "K66-D240",
        ],
      },
    },
  },
  K68: {
    en_name: "Yuen Long Industrial Estate to Yuen Long Park (Circular)",
    tc_name: "元朗工業邨至元朗公園 (循環綫)",
    bound: {
      UP: {
        dest: "CIR",
        stops: [
          "K68-U010",
          "K68-U020",
          "K68-U030",
          "K68-U040",
          "K68-U050",
          "K68-U060",
          "K68-U070",
          "K68-U080",
          "K68-U090",
          "K68-U100",
          "K68-U110",
          "K68-U120",
          "K68-U130",
          "K68-U140",
          "K68-U150",
          "K68-U160",
          "K68-U170",
          "K68-D010",
          "K68-D020",
          "K68-D030",
          "K68-D040",
          "K68-D050",
          "K68-D060",
          "K68-D070",
          "K68-D080",
          "K68-D090",
          "K68-D100",
          "K68-D110",
          "K68-D120",
          "K68-D130",
          "K68-D140",
          "K68-D150",
          "K68-D160",
          "K68-D170",
          "K68-D180",
          "K68-D190",
          "K68-D200",
          "K68-U011",
        ],
      },
    },
  },
  K73: {
    en_name: "Tin Heng to Yuen Long West",
    tc_name: "天恆至元朗西",
    bound: {
      UP: {
        dest: "YLW",
        stops: [
          "K73-U010",
          "K73-U020",
          "K73-U030",
          "K73-U040",
          "K73-U050",
          "K73-U060",
          "K73-U070",
          "K73-U080",
          "K73-U090",
          "K73-U100",
          "K73-U110",
          "K73-U120",
        ],
      },
      DOWN: {
        dest: "TH",
        stops: [
          "K73-D010",
          "K73-D020",
          "K73-D030",
          "K73-D040",
          "K73-D050",
          "K73-D060",
          "K73-D070",
          "K73-D080",
          "K73-D090",
          "K73-D100",
          "K73-D110",
          "K73-D120",
          "K73-D130",
          "K73-D140",
          "K73-D150",
          "K73-D160",
        ],
      },
    },
  },
  K74: {
    en_name: "Tin Shui Wai Town Centre to Au Tau (Circular)",
    tc_name: "天水圍市中心至凹頭 (循環綫)",
    bound: {
      UP: {
        dest: "CIR",
        stops: [
          "K74-U001",
          "K74-U004",
          "K74-U007",
          "K74-U010",
          "K74-U020",
          "K74-U030",
          "K74-U040",
          "K74-U050",
          "K74-U060",
          "K74-U070",
          "K74-U080",
          "K74-U090",
          "K74-U100",
          "K74-D010",
          "K74-D020",
          "K74-D030",
          "K74-D040",
          "K74-D050",
          "K74-D060",
          "K74-D070",
          "K74-D080",
          "K74-D090",
          "K74-U011",
          "K74-D100",
          "K74-D110",
          "K74-U002",
        ],
      },
    },
  },
  K75A: {
    en_name: "Tin Shui Wai Station to Hung Shui Kiu (Circular)",
    tc_name: "天水圍站至洪水橋 (循環綫)",
    bound: {
      UP: {
        dest: "CIR",
        stops: [
          "K75A-U010",
          "K75A-U020",
          "K75A-U030",
          "K75A-D010",
          "K75A-D020",
          "K75A-D030",
          "K75A-D040",
          "K75A-D050",
          "K75A-D060",
          "K75A-D070",
          "K75A-D080",
          "K75A-D090",
          "K75A-D100",
          "K75A-D110",
          "K75A-U011",
        ],
      },
    },
  },
  K75P: {
    en_name: "Tin Shui to Hung Shui Kiu (Circular)",
    tc_name: "天瑞至洪水橋 (循環綫)",
    bound: {
      UP: {
        dest: "CIR",
        stops: [
          "K75P-U010",
          "K75P-U020",
          "K75P-U030",
          "K75P-U040",
          "K75P-U050",
          "K75P-U060",
          "K75P-U070",
          "K75P-U080",
          "K75P-U090",
          "K75P-U100",
          "K75P-U110",
          "K75P-U120",
          "K75P-U130",
          "K75P-U140",
          "K75P-D010",
          "K75P-D020",
          "K75P-D030",
          "K75P-D040",
          "K75P-D050",
          "K75P-D060",
          "K75P-D070",
          "K75P-D080",
          "K75P-U011",
        ],
      },
    },
  },
  K76: {
    en_name: "Tin Heng to Tin Shui Wai Station",
    tc_name: "天恆至天水圍站",
    bound: {
      UP: {
        dest: "TSWS",
        stops: ["K76-U010", "K76-U020", "K76-U030", "K76-U040", "K76-U050"],
      },
      DOWN: {
        dest: "TH",
        stops: ["K76-D010", "K76-D020", "K76-D030", "K76-D040"],
      },
    },
  },
};

const dest = {
  CIR: {
    en_name: "Circular",
    tc_name: "循環綫",
  },
  TPMS: {
    en_name: "Tai Po Market Station",
    tc_name: "大埔墟站",
  },
  EG: {
    en_name: "Eightland Garden",
    tc_name: "八號花園",
  },
  KF: {
    en_name: "Kwong Fuk",
    tc_name: "廣福",
  },
  FS: {
    en_name: "Fu Shin",
    tc_name: "富善",
  },
  FT: {
    en_name: "Fu Tai",
    tc_name: "富泰",
  },
  CPB: {
    en_name: "Castle Peak Bay",
    tc_name: "青山灣",
  },
  TL: {
    en_name: "Tai Lam",
    tc_name: "大欖",
  },
  TMS: {
    en_name: "Tai Lam",
    tc_name: "屯門站",
  },
  LKT: {
    en_name: "Lung Kwu Tan",
    tc_name: "龍鼓灘",
  },
  TT: {
    en_name: "Tsang Tsui",
    tc_name: "曾咀",
  },
  YLS: {
    en_name: "Yuen Long Station",
    tc_name: "元朗站",
  },
  LFS: {
    en_name: "Lau Fau Shan",
    tc_name: "流浮山",
  },
  LP: {
    en_name: "Long Ping",
    tc_name: "朗屏",
  },
  TTWNTT: {
    en_name: "Tai Tong Wong Nai Tun Tsuen",
    tc_name: "大棠黃泥墩村",
  },
  TH: {
    en_name: "Tin Heng",
    tc_name: "天恆",
  },
  YLW: {
    en_name: "Yuen Long West",
    tc_name: "元朗西",
  },
  TSWS: {
    en_name: "Tin Shui Wai Station",
    tc_name: "天水圍站",
  },
  SKW: {
    en_name: "So Kwun Wat",
    tc_name: "掃管笏",
  },
  YWV: {
    en_name: "Yuet Wu Villa",
    tc_name: "悅湖山莊",
  },
};

const stops = {
  //route 506
  "506-U010": {
    tc_name: "屯門碼頭",
    en_name: "Tuen Mun Ferry Pier",
    lat: "22.372986",
    lon: "113.966502",
    connections: {
      LR: "1",
    },
  },
  "506-U020": {
    tc_name: "美樂花園",
    en_name: "Melody Garden",
    lat: "22.375834",
    lon: "113.960628",
    connections: {
      LR: "10",
    },
  },
  "506-U030": {
    tc_name: "輕鐵蝴蝶站",
    en_name: "LR Butterfly Stop",
    lat: "22.378364",
    lon: "113.961965",
    connections: {
      LR: "15",
    },
  },
  "506-U040": {
    tc_name: "輕鐵車廠站",
    en_name: "Light Rail Depot Stop",
    lat: "22.382203",
    lon: "113.96359",
    connections: {
      LR: "20",
    },
  },
  "506-U050": {
    tc_name: "輕鐵龍門站",
    en_name: "LR Lung Mun Stop",
    lat: "22.385399",
    lon: "113.965222",
    connections: {
      LR: "30",
    },
  },
  "506-U060": {
    tc_name: "輕鐵青雲站",
    en_name: "LR Tsing Wun Stop",
    lat: "22.393627",
    lon: "113.96752",
    connections: {
      LR: "50",
    },
  },
  "506-U070": {
    tc_name: "輕鐵建安站",
    en_name: "LR Kin On Stop",
    lat: "22.395064",
    lon: "113.969953",
    connections: {
      LR: "60",
    },
  },
  "506-U080": {
    tc_name: "港鐵屯門站",
    en_name: "MTR Tuen Mun Station",
    lat: "22.394117",
    lon: "113.973992",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "506-U090": {
    tc_name: "屯門市中心",
    en_name: "Tuen Mun Town Centre",
    lat: "22.391352",
    lon: "113.975474",
    connections: {
      LR: "280",
    },
  },
  "506-U100": {
    tc_name: "安定邨",
    en_name: "On Ting Estate",
    lat: "22.387312",
    lon: "113.975341",
    connections: {
      LR: "270",
    },
  },
  "506-U110": {
    tc_name: "輕鐵三聖站",
    en_name: "LR Sam Shing Stop",
    lat: "22.382916",
    lon: "113.976276",
    connections: {
      LR: "920",
    },
  },
  "506-D010": {
    tc_name: "兆麟",
    en_name: "Siu Lun",
    lat: "22.38551",
    lon: "113.9767",
  },
  "506-D020": {
    tc_name: "友愛邨",
    en_name: "Yau Oi Estate",
    lat: "22.387783",
    lon: "113.975189",
    connections: {
      LR: "270",
    },
  },
  "506-D030": {
    tc_name: "輕鐵市中心站",
    en_name: "LR Town Centre Stop",
    lat: "22.392125",
    lon: "113.975128",
    connections: {
      LR: "280",
    },
  },
  "506-D040": {
    tc_name: "輕鐵屯門站 (港鐵屯門站)",
    en_name: "LR Tuen Mun Stop (MTR Tuen Mun Station)",
    lat: "22.393937",
    lon: "113.973896",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "506-D050": {
    tc_name: "輕鐵建安站",
    en_name: "LR Kin On Stop",
    lat: "22.394687",
    lon: "113.970746",
    connections: {
      LR: "60",
    },
  },
  "506-D060": {
    tc_name: "輕鐵青雲站",
    en_name: "LR Tsing Wun Stop",
    lat: "22.393382",
    lon: "113.967707",
    connections: {
      LR: "50",
    },
  },
  "506-D070": {
    tc_name: "聖彼得堂",
    en_name: "SKH St. Peter's Church",
    lat: "22.391722",
    lon: "113.967726",
  },
  "506-D080": {
    tc_name: "富健花園",
    en_name: "Glorious Garden",
    lat: "22.383618",
    lon: "113.964478",
  },
  "506-D090": {
    tc_name: "新屯門中心",
    en_name: "Sun Tuen Mun Centre",
    lat: "22.382269",
    lon: "113.963833",
    connections: {
      LR: "20",
    },
  },
  "506-D100": {
    tc_name: "輕鐵蝴蝶站",
    en_name: "LR Butterfly Stop",
    lat: "22.377547",
    lon: "113.961481",
    connections: {
      LR: "15",
    },
  },
  "506-D110": {
    tc_name: "蝴蝶邨蝶心樓",
    en_name: "Tip Sum House, Butterfly Estate",
    lat: "22.374219",
    lon: "113.962106",
    connections: {
      LR: "10",
    },
  },
  "506-D120": {
    tc_name: "湖景邨湖碧樓",
    en_name: "Wu Pik House, Wu King Estate",
    lat: "22.373549",
    lon: "113.964341",
  },
  "506-D130": {
    tc_name: "海翠花園",
    en_name: "Pierhead Garden",
    lat: "22.373192",
    lon: "113.966053",
    connections: {
      LR: "1",
    },
  },
  "506-U011": {
    tc_name: "屯門碼頭",
    en_name: "Tuen Mun Ferry Pier",
    lat: "22.372986",
    lon: "113.966502",
    connections: {
      LR: "1",
    },
  },
  //Route K12
  "K12-U010": {
    tc_name: "大埔墟站",
    en_name: "Tai Po Market Station",
    lat: "22.444414",
    lon: "114.169471",
    connections: {
      EAL: "TAP",
    },
  },
  "K12-U020": {
    tc_name: "大埔超級城",
    en_name: "Tai Po Mega Mall",
    lat: "22.450971",
    lon: "114.169957",
  },
  "K12-U030": {
    tc_name: "八號花園",
    en_name: "Eightland Garden",
    lat: "22.452836",
    lon: "114.166496",
  },
  "K12-D010": {
    tc_name: "八號花園",
    en_name: "Eightland Garden",
    lat: "22.452836",
    lon: "114.166496",
  },
  "K12-D020": {
    tc_name: "大埔超級城",
    en_name: "Tai Po Mega Mall",
    lat: "22.451278",
    lon: "114.170087",
  },
  "K12-D030": {
    tc_name: "新達廣場",
    en_name: "Uptown Plaza",
    lat: "22.443712",
    lon: "114.16991",
    connections: {
      EAL: "TAP",
    },
  },
  "K12-D040": {
    tc_name: "大埔墟站",
    en_name: "Tai Po Market Station",
    lat: "22.444414",
    lon: "114.169471",
  },
  //Route K14
  "K14-D010": {
    tc_name: "大埔超級城",
    en_name: "Tai Po Mega Mall",
    lat: "22.451278",
    lon: "114.170087",
  },
  "K14-D020": {
    tc_name: "新達廣場",
    en_name: "Uptown Plaza",
    lat: "22.443712",
    lon: "114.16991",
    connections: {
      EAL: "TAP",
    },
  },
  "K14-D030": {
    tc_name: "大埔墟站",
    en_name: "Tai Po Market Station",
    lat: "22.444414",
    lon: "114.169471",
  },
  //Route K17
  "K17-U010": {
    tc_name: "大埔墟站",
    en_name: "Tai Po Market Station",
    lat: "22.444414",
    lon: "114.169471",
    connections: {
      EAL: "TAP",
    },
  },
  "K17-U020": {
    tc_name: "大埔中心第五期",
    en_name: "Tai Po Centre Phase 5",
    lat: "22.453021",
    lon: "114.172331",
  },
  "K17-U030": {
    tc_name: "怡雅苑",
    en_name: "Yee Nga Court",
    lat: "22.454538",
    lon: "114.174428",
  },
  "K17-U040": {
    tc_name: "富善",
    en_name: "Fu Shin",
    lat: "22.454322",
    lon: "114.174098",
  },
  "K17-D010": {
    tc_name: "富善",
    en_name: "Fu Shin",
    lat: "22.454322",
    lon: "114.174098",
  },
  "K17-D020": {
    tc_name: "新達廣場",
    en_name: "Uptown Plaza",
    lat: "22.443712",
    lon: "114.16991",
    connections: {
      EAL: "TAP",
    },
  },
  "K17-D030": {
    tc_name: "大埔墟站",
    en_name: "Tai Po Market Station",
    lat: "22.444414",
    lon: "114.169471",
  },
  //Route K18
  "K18-U010": {
    tc_name: "大埔墟站",
    en_name: "Tai Po Market Station",
    lat: "22.444414",
    lon: "114.169471",
    connections: {
      EAL: "TAP",
    },
  },
  "K18-U020": {
    tc_name: "宏福苑",
    en_name: "Wang Fuk Court",
    lat: "22.447531",
    lon: "114.17473",
  },
  "K18-U030": {
    tc_name: "廣福",
    en_name: "Kwong Fuk",
    lat: "22.4487",
    lon: "114.174398",
  },
  "K18-D010": {
    tc_name: "廣福",
    en_name: "Kwong Fuk",
    lat: "22.4487",
    lon: "114.174398",
  },
  "K18-D020": {
    tc_name: "新達廣場",
    en_name: "Uptown Plaza",
    lat: "22.443712",
    lon: "114.16991",
    connections: {
      EAL: "TAP",
    },
    
  },
  "K18-D030": {
    tc_name: "大埔墟站",
    en_name: "Tai Po Market Station",
    lat: "22.444414",
    lon: "114.169471",
  },
  //Route K51
  "K51-U010": {
    tc_name: "富泰",
    en_name: "FuTai",
    lat: "22.413286",
    lon: "113.982895",
  },
  "K51-U020": {
    tc_name: "聚康山莊",
    en_name: "Beneville",
    lat: "22.412025",
    lon: "113.983771",
  },
  "K51-U030": {
    tc_name: "嶺南大學",
    en_name: "Lingnan University",
    lat: "22.41059",
    lon: "113.982387",
  },
  "K51-U040": {
    tc_name: "彩暉花園",
    en_name: "Brilliant Garden",
    lat: "22.408575",
    lon: "113.980046",
  },
  "K51-U050": {
    tc_name: "港鐵兆康站 (南), (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (South), (LR Siu Hong Stop)",
    lat: "22.410247",
    lon: "113.978583",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K51-U060": {
    tc_name: "井財街",
    en_name: "Tseng Choi Street",
    lat: "22.40205",
    lon: "113.9776",
  },
  "K51-U070": {
    tc_name: "雅都商場",
    en_name: "ACME Shopping Arcade",
    lat: "22.39834",
    lon: "113.9752",
  },
  "K51-U080": {
    tc_name: "德政圍 (港鐵屯門站)",
    en_name: "Tak Ching Court (MTR Tuen Mun Station)",
    lat: "22.39494",
    lon: "113.9746",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K51-U090": {
    tc_name: "屯門市中心 (輕鐵市中心站)",
    en_name: "Tuen Mun Town Centre (LR Town Centre Stop)",
    lat: "22.39153",
    lon: "113.9755",
    connections: {
      LR: "280",
    },
  },
  "K51-U100": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.3906",
    lon: "113.9788",
  },
  "K51-U110": {
    tc_name: "恒順園",
    en_name: "Handsome Court",
    lat: "22.38771",
    lon: "113.9807",
  },
  "K51-U120": {
    tc_name: "恒豐園",
    en_name: "Harvest Garden",
    lat: "22.38519",
    lon: "113.981",
  },
  "K51-U130": {
    tc_name: "三聖邨",
    en_name: "Sam Shing Estate",
    lat: "22.381748",
    lon: "113.978862",
  },
  "K51-U140": {
    tc_name: "青山灣",
    en_name: "Castle Peak Beach",
    lat: "22.378898",
    lon: "113.980751",
  },
  "K51-U150": {
    tc_name: "海景花園",
    en_name: "Seaview Garden",
    lat: "22.377938",
    lon: "113.983475",
  },
  "K51-U160": {
    tc_name: "咖啡灣",
    en_name: "Cafeteria Beach",
    lat: "22.374926",
    lon: "113.986745",
  },
  "K51-U170": {
    tc_name: "黃金泳灘",
    en_name: "Golden Beach",
    lat: "22.373784",
    lon: "113.990756",
  },
  "K51-U180": {
    tc_name: "香港黃金海岸",
    en_name: "Hong Kong Gold Coast",
    lat: "22.372025",
    lon: "113.993574",
  },
  "K51-U190": {
    tc_name: "嘉禾里村",
    en_name: "Kar Wo Lei Tsuen",
    lat: "22.36945",
    lon: "113.9954",
  },
  "K51-U200": {
    tc_name: "小秀村",
    en_name: "Siu Sau Tsuen",
    lat: "22.36817",
    lon: "113.9991",
  },
  "K51-U210": {
    tc_name: "愛琴灣",
    en_name: "The Aegean",
    lat: "22.36627",
    lon: "114.0033",
  },
  "K51-U220": {
    tc_name: "小欖新村",
    en_name: "Siu Lam San Tsuen",
    lat: "22.36638",
    lon: "114.0063",
  },
  "K51-U230": {
    tc_name: "小欖村",
    en_name: "Siu Lam Tsuen",
    lat: "22.3663",
    lon: "114.0113",
  },
  "K51-U240": {
    tc_name: "小欖澄麗路",
    en_name: "Ching Lai Road Siu Lam",
    lat: "22.36497",
    lon: "114.0133",
  },
  "K51-U250": {
    tc_name: "大欖",
    en_name: "Tai Lam",
    lat: "22.362495",
    lon: "114.019113",
  },
  "K51-D010": {
    tc_name: "大欖",
    en_name: "Tai Lam",
    lat: "22.362495",
    lon: "114.019113",
  },
  "K51-D020": {
    tc_name: "小欖",
    en_name: "Siu Lam",
    lat: "22.364165",
    lon: "114.014994",
  },
  "K51-D030": {
    tc_name: "小欖澄麗路",
    en_name: "Ching Lai Road Siu Lam",
    lat: "22.365696",
    lon: "114.01244",
  },
  "K51-D040": {
    tc_name: "小欖村",
    en_name: "Siu Lam Tsuen",
    lat: "22.366338",
    lon: "114.00949",
  },
  "K51-D050": {
    tc_name: "小欖新村",
    en_name: "Siu Lam San Tsuen",
    lat: "22.366102",
    lon: "114.005524",
  },
  "K51-D060": {
    tc_name: "愛琴灣",
    en_name: "The Aegean",
    lat: "22.366573",
    lon: "114.001616",
  },
  "K51-D070": {
    tc_name: "小秀上村",
    en_name: "Siu Sau Sheung Tsuen",
    lat: "22.368003",
    lon: "113.999085",
  },
  "K51-D080": {
    tc_name: "龍珠島",
    en_name: "Pearl Island",
    lat: "22.368035",
    lon: "113.996264",
  },
  "K51-D090": {
    tc_name: "香港黃金海岸",
    en_name: "Hong Kong Gold Coast",
    lat: "22.371285",
    lon: "113.993882",
  },
  "K51-D100": {
    tc_name: "黃金泳灘",
    en_name: "Golden Beach",
    lat: "22.373628",
    lon: "113.991213",
  },
  "K51-D110": {
    tc_name: "咖啡灣",
    en_name: "Cafeteria Beach",
    lat: "22.3759",
    lon: "113.985635",
  },
  "K51-D120": {
    tc_name: "碧翠花園",
    en_name: "Bayview Terrace",
    lat: "22.377927",
    lon: "113.983242",
  },
  "K51-D130": {
    tc_name: "青山灣碼頭",
    en_name: "Castle Peak Bay Pier",
    lat: "22.378957",
    lon: "113.980602",
  },
  "K51-D140": {
    tc_name: "三聖邨",
    en_name: "Sam Shing Estate",
    lat: "22.381214",
    lon: "113.979092",
  },
  "K51-D150": {
    tc_name: "恆福花園 (輕鐵三聖站)",
    en_name: "Hanford Garden (LR Sam Shing Stop)",
    lat: "22.382064",
    lon: "113.977151",
    connections: {
      LR: "920",
    },
  },
  "K51-D160": {
    tc_name: "胡陳金枝中學",
    en_name: "Mrs Aw Boon Haw Secondary School",
    lat: "22.383774",
    lon: "113.97939",
  },
  "K51-D170": {
    tc_name: "青善遊樂場",
    en_name: "Tsing Sin Playground",
    lat: "22.384602",
    lon: "113.980638",
  },
  "K51-D180": {
    tc_name: "置樂花園",
    en_name: "Chi Lok Fa Yuen",
    lat: "22.387355",
    lon: "113.98069",
  },
  "K51-D190": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.390433",
    lon: "113.978805",
  },
  "K51-D200": {
    tc_name: "輕鐵市中心站",
    en_name: "LR Town Centre Stop",
    lat: "22.392116",
    lon: "113.975082",
    connections: {
      LR: "280",
    },
  },
  "K51-D210": {
    tc_name: "港鐵屯門站 (輕鐵屯門站)",
    en_name: "MTR Tuen Mun Station (LR Tuen Mun Stop)",
    lat: "22.395021",
    lon: "113.974444",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K51-D220": {
    tc_name: "聖公會聖西門呂明才中學",
    en_name: "SKH St. Simon's Lui Ming Choi Secondary School",
    lat: "22.397311",
    lon: "113.974853",
  },
  "K51-D230": {
    tc_name: "景峰花園",
    en_name: "Prime View Garden",
    lat: "22.40334",
    lon: "113.979247",
    connections: {
      LR: "330",
    },
  },
  "K51-D240": {
    tc_name: "輕鐵鳳地站",
    en_name: "LR Fung Tei Stop",
    lat: "22.407254",
    lon: "113.978641",
    connections: {
      LR: "340",
    },
  },
  "K51-D250": {
    tc_name: "港鐵兆康站 (南), (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (South), (LR Siu Hong Stop)",
    lat: "22.410378",
    lon: "113.978607",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K51-D260": {
    tc_name: "彩暉花園",
    en_name: "Brilliant Garden",
    lat: "22.408779",
    lon: "113.980397",
  },
  "K51-D270": {
    tc_name: "嶺南大學",
    en_name: "Lingnan University",
    lat: "22.410694",
    lon: "113.982212",
  },
  "K51-D280": {
    tc_name: "倚嶺南庭",
    en_name: "South Hillcrest",
    lat: "22.413286",
    lon: "113.982895",
  },
  "K51-D290": {
    tc_name: "富泰",
    en_name: "Fu Tai",
    lat: "22.413286",
    lon: "113.982895",
  },
  // Route K51A
  "K51A-U010": {
    tc_name: "富泰",
    en_name: "Fu Tai",
    lat: "22.413286",
    lon: "113.982895",
  },
  "K51A-U020": {
    tc_name: "聚康山莊",
    en_name: "Beneville",
    lat: "22.412025",
    lon: "113.983771",
  },
  "K51A-U030": {
    tc_name: "嶺南大學",
    en_name: "Lingnan University",
    lat: "22.41059",
    lon: "113.982387",
  },
  "K51A-U040": {
    tc_name: "彩暉花園",
    en_name: "Brilliant Garden",
    lat: "22.408575",
    lon: "113.980046",
  },
  "K51A-U050": {
    tc_name: "港鐵兆康站 (南) (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (South) (LR Siu Hong Stop)",
    lat: "22.410247",
    lon: "113.978583",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K51A-U060": {
    tc_name: "井財街",
    en_name: "Tseng Choi Street",
    lat: "22.40205",
    lon: "113.9776",
  },
  "K51A-U070": {
    tc_name: "雅都商場",
    en_name: "ACME Shopping Arcade",
    lat: "22.39834",
    lon: "113.9752",
  },
  "K51A-U080": {
    tc_name: "德政圍 (港鐵屯門站)",
    en_name: "Tak Ching Court (MTR Tuen Mun Station)",
    lat: "22.39494",
    lon: "113.9746",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K51A-U090": {
    tc_name: "屯門市中心 (輕鐵市中心站)",
    en_name: "Tuen Mun Town Centre (LR Town Centre Stop)",
    lat: "22.39153",
    lon: "113.9755",
    connections: {
      LR: "280",
    },
  },
  "K51A-U100": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.3906",
    lon: "113.9788",
  },
  "K51A-U110": {
    tc_name: "恒順園",
    en_name: "Handsome Court",
    lat: "22.38771",
    lon: "113.9807",
  },
  "K51A-U120": {
    tc_name: "恒豐園",
    en_name: "Harvest Garden",
    lat: "22.38519",
    lon: "113.981",
  },
  "K51A-U130": {
    tc_name: "三聖邨",
    en_name: "Sam Shing Estate",
    lat: "22.381748",
    lon: "113.978862",
  },
  "K51A-U140": {
    tc_name: "青山灣",
    en_name: "Castle Peak Beach",
    lat: "22.378898",
    lon: "113.980751",
  },
  "K51A-U150": {
    tc_name: "海景花園",
    en_name: "Seaview Garden",
    lat: "22.377938",
    lon: "113.983475",
  },

  "K51A-U160": {
    tc_name: "咖啡灣",
    en_name: "Cafeteria Beach",
    lat: "22.374926",
    lon: "113.986745",
  },
  "K51A-U170": {
    tc_name: "黃金泳灘",
    en_name: "Golden Beach",
    lat: "22.373784",
    lon: "113.990756",
  },
  "K51A-U180": {
    tc_name: "香港黃金海岸",
    en_name: "Hong Kong Gold Coast",
    lat: "22.372025",
    lon: "113.993574",
  },
  "K51A-U190": {
    tc_name: "愛琴海岸",
    en_name: "Aegean Coast",
    lat: "22.371605",
    lon: "113.9954",
  },
  "K51A-U200": {
    tc_name: "掃管笏變電站",
    en_name: "So Kwun Wat Sub- station",
    lat: "22.373878",
    lon: "113.996144",
  },
  "K51A-U210": {
    tc_name: "掃管笏村",
    en_name: "So Kwun Wat Tsuen",
    lat: "22.375743",
    lon: "113.999829",
  },
  "K51A-U220": {
    tc_name: "掃管笏 (鄭任安夫人千禧小學)",
    en_name: "So Kwun Wat (Mrs. Cheng Yam On Millennium School)",
    lat: "22.372023",
    lon: "114.003593",
  },

  "K51A-U230": {
    tc_name: "掃管笏路",
    en_name: "So Kwun Wat Road",
    lat: "22.374216",
    lon: "114.002295",
  },
  "K51A-U240": {
    tc_name: "管翠路 18 號",
    en_name: "18 Kwun Chui Road",
    lat: "22.373866",
    lon: "114.001024",
  },
  "K51A-U250": {
    tc_name: "掃管笏村",
    en_name: "So Kwun Wat Tsuen",
    lat: "22.375743",
    lon: "113.999829",
  },
  "K51A-D010": {
    tc_name: "掃管笏村",
    en_name: "So Kwun Wat Tsuen",
    lat: "22.375743",
    lon: "113.999829",
  },
  "K51A-D020": {
    tc_name: "掃管笏 (鄭任安夫人千禧小學)",
    en_name: "So Kwun Wat (Mrs. Cheng Yam On Millennium School)",
    lat: "22.372023",
    lon: "114.003593",
  },
  "K51A-D030": {
    tc_name: "掃管笏路",
    en_name: "So Kwun Wat Road",
    lat: "22.374216",
    lon: "114.002295",
  },
  "K51A-D040": {
    tc_name: "管翠路18號",
    en_name: "18 Kwun Chui Road",
    lat: "22.373866",
    lon: "114.001024",
  },
  "K51A-D050": {
    tc_name: "管翠路",
    en_name: "Kwun Chui Road",
    lat: "22.375123",
    lon: "113.997707",
  },
  "K51A-D060": {
    tc_name: "愛琴海岸",
    en_name: "Aegean Coast",
    lat: "22.371473",
    lon: "113.995381",
  },
  "K51A-D070": {
    tc_name: "香港黃金海岸",
    en_name: "Hong Kong Gold Coast",
    lat: "22.371294",
    lon: "113.993906",
  },
  "K51A-D080": {
    tc_name: "黃金泳灘",
    en_name: "Golden Beach",
    lat: "22.373628",
    lon: "113.991213",
  },
  "K51A-D090": {
    tc_name: "咖啡灣",
    en_name: "Cafeteria Beach",
    lat: "22.3759",
    lon: "113.985635",
  },
  "K51A-D100": {
    tc_name: "碧翠花園",
    en_name: "Bayview Terrace",
    lat: "22.377927",
    lon: "113.983242",
  },
  "K51A-D110": {
    tc_name: "青山灣碼頭",
    en_name: "Castle Peak Bay Pier",
    lat: "22.378957",
    lon: "113.980602",
  },
  "K51A-D120": {
    tc_name: "三聖邨",
    en_name: "Sam Shing Estate",
    lat: "22.381214",
    lon: "113.979092",
  },
  "K51A-D140": {
    tc_name: "胡陳金枝中學",
    en_name: "Mrs Aw Boon Haw Secondary School",
    lat: "22.383774",
    lon: "113.97939",
  },
  "K51A-D150": {
    tc_name: "青善遊樂場",
    en_name: "Tsing Sin Playground",
    lat: "22.384602",
    lon: "113.980638",
  },
  "K51A-D160": {
    tc_name: "置樂花園",
    en_name: "Chi Lok Fa Yuen",
    lat: "22.387355",
    lon: "113.98069",
  },
  "K51A-D170": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.390433",
    lon: "113.978805",
  },
  "K51A-D180": {
    tc_name: "輕鐵市中心站",
    en_name: "LR Town Centre Stop",
    lat: "22.392116",
    lon: "113.975082",
    connections: {
      LR: "280",
    },
  },
  "K51A-D190": {
    tc_name: "港鐵屯門站 (輕鐵屯門站)",
    en_name: "MTR Tuen Mun Station (LR Tuen Mun Stop)",
    lat: "22.395021",
    lon: "113.974444",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K51A-D200": {
    tc_name: "聖公會聖西門呂明才中學",
    en_name: "SKH St. Simon's Lui Ming Choi Secondary School",
    lat: "22.397311",
    lon: "113.974853",
  },
  "K51A-D210": {
    tc_name: "景峰花園",
    en_name: "Prime View Garden",
    lat: "22.40334",
    lon: "113.979247",
  },
  "K51A-D220": {
    tc_name: "輕鐵鳳地站",
    en_name: "LR Fung Tei Stop",
    lat: "22.407254",
    lon: "113.978641",
    connections: {
      LR: "340",
    },
  },
  "K51A-D230": {
    tc_name: "港鐵兆康站 (南) (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (South) (LR Siu Hong Stop)",
    lat: "22.410378",
    lon: "113.978607",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K51A-D240": {
    tc_name: "彩暉花園",
    en_name: "Brilliant Garden",
    lat: "22.408779",
    lon: "113.980397",
  },
  "K51A-D250": {
    tc_name: "嶺南大學",
    en_name: "Lingnan University",
    lat: "22.410694",
    lon: "113.982212",
  },
  "K51A-D260": {
    tc_name: "倚嶺南庭",
    en_name: "South Hillcrest",
    lat: "22.411927",
    lon: "113.983128",
  },
  "K51A-D270": {
    tc_name: "富泰",
    en_name: "Fu Tai",
    lat: "22.413286",
    lon: "113.982895",
  },

  // Route K52
  "K52-nU010": {
    tc_name: "悅湖山莊",
    en_name: "Yuet Wu Villa",
    lat: "22.375261",
    lon: "113.968532",
  },
  "K52-nU020": {
    tc_name: "邁亞美海灣",
    en_name: "Miami Beach Towers",
    lat: "22.372808",
    lon: "113.970095",
  },
  "K52-nU030": {
    tc_name: "屯門碼頭",
    en_name: "Tuen Mun Ferry Pier",
    lat: "22.372801",
    lon: "113.967391",
    connections: {
      LR: "1",
    },
  },
  "K52-nU040": {
    tc_name: "湖景邨 湖畔樓",
    en_name: "Wu Boon House, Wu King Estate",
    lat: "22.374496",
    lon: "113.965605",
  },
  "K52-nU050": {
    tc_name: "湖景邨 湖翠樓",
    en_name: "Wu Tsui House, Wu King Estate",
    lat: "22.376739",
    lon: "113.966289",
  },
  "K52-nU060": {
    tc_name: "屯門中央廣場",
    en_name: "Tuen Mun Central Square",
    lat: "22.380902",
    lon: "113.972021",
  },
  "K52-nU070": {
    tc_name: "輕鐵三聖站",
    en_name: "LR Sam Shing Stop",
    lat: "22.381216",
    lon: "113.972293",
    connections: {
      LR: "920",
    },
  },
  "K52-nU080": {
    tc_name: "胡陳金枝中學",
    en_name: "Mrs Aw Boon Haw Secondary School",
    lat: "22.383774",
    lon: "113.97939",
  },
  "K52-nU090": {
    tc_name: "青善遊樂場",
    en_name: "Tsing Sin Playground",
    lat: "22.38457",
    lon: "113.98065",
  },
  "K52-nU100": {
    tc_name: "置樂花園",
    en_name: "Chi Lok Fa Yuen",
    lat: "22.387385",
    lon: "113.980666",
  },
  "K52-nU110": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.390462",
    lon: "113.97885",
  },
  "K52-nU120": {
    tc_name: "輕鐵市中心站",
    en_name: "LR Town Centre Stop",
    lat: "22.392116",
    lon: "113.975082",
    connections: {
      LR: "280",
    },
  },
  "K52-nU130": {
    tc_name: "屯門站",
    en_name: "Tuen Mun Station",
    lat: "22.394225",
    lon: "113.973358",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K52-nU140": {
    tc_name: "輕鐵屯門站",
    en_name: "LR Tuen Mun Stop",
    lat: "22.393937",
    lon: "113.973896",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K52-nU150": {
    tc_name: "輕鐵建安站",
    en_name: "LR Kin On Stop",
    lat: "22.394687",
    lon: "113.970746",
    connections: {
      LR: "60",
    },
  },
  "K52-nU160": {
    tc_name: "輕鐵青雲站",
    en_name: "LR Tsing Wun Stop",
    lat: "22.393382",
    lon: "113.967707",
    connections: {
      LR: "50",
    },
  },
  "K52-nU170": {
    tc_name: "聖彼得堂",
    en_name: "SKH St. Peter's Church",
    lat: "22.391722",
    lon: "113.967726",
  },
  "K52-nU180": {
    tc_name: "富健花園",
    en_name: "Glorious Garden",
    lat: "22.383618",
    lon: "113.964478",
  },
  "K52-nU190": {
    tc_name: "新屯門中心",
    en_name: "Sun Tuen Mun Centre",
    lat: "22.382269",
    lon: "113.963833",
  },
  "K52-nU200": {
    tc_name: "輕鐵蝴蝶站",
    en_name: "LR Butterfly Stop",
    lat: "22.377549",
    lon: "113.961472",
    connections: {
      LR: "15",
    },
  },
  "K52-nU210": {
    tc_name: "屯門公眾騎術學校",
    en_name: "Tuen Mun Public Riding School",
    lat: "22.375483",
    lon: "113.959318",
  },
  "K52-nU220": {
    tc_name: "蝴蝶灣公園",
    en_name: "Butterfly Beach Park",
    lat: "22.37319",
    lon: "113.95473",
  },
  "K52-nU230": {
    tc_name: "望后石",
    en_name: "Pillar Point",
    lat: "22.368528",
    lon: "113.948898",
  },
  "K52-nU240": {
    tc_name: "政府車場",
    en_name: "Government Depot",
    lat: "22.366727",
    lon: "113.94371",
  },
  "K52-nU250": {
    tc_name: "內河碼頭",
    en_name: "River Trade Terminal",
    lat: "22.36857",
    lon: "113.93822",
  },
  "K52-nU260": {
    tc_name: "環保園",
    en_name: "EcoPark",
    lat: "22.36999",
    lon: "113.93403",
  },
  "K52-nU270": {
    tc_name: "紹榮鋼鐵",
    en_name: "Shiu Wing Steel Mill",
    lat: "22.36995",
    lon: "113.92874",
  },
  "K52-nU280": {
    tc_name: "沙埔崗 312 號",
    en_name: "No.312 Sha Po Kong",
    lat: "22.386382",
    lon: "113.921122",
  },
  "K52-nU290": {
    tc_name: "沙埔崗 177 號",
    en_name: "No.177 Sha Po Kong",
    lat: "22.388034",
    lon: "113.920786",
  },
  "K52-nU300": {
    tc_name: "沙埔崗 127 號",
    en_name: "No.127 Sha Po Kong",
    lat: "22.389307",
    lon: "113.920224",
  },
  "K52-nU310": {
    tc_name: "龍鼓灘",
    en_name: "Lung Kwu Tan",
    lat: "22.390617",
    lon: "113.920146",
  },
  "K52-nD010": {
    tc_name: "龍鼓灘",
    en_name: "Lung Kwu Tan",
    lat: "22.390617",
    lon: "113.920146",
  },
  "K52-nD020": {
    tc_name: "沙埔崗 127 號",
    en_name: "No.127 Sha Po Kong",
    lat: "22.389103",
    lon: "113.920301",
  },
  "K52-nD030": {
    tc_name: "沙埔崗 177 號",
    en_name: "No.177 Sha Po Kong",
    lat: "22.388058",
    lon: "113.920786",
  },
  "K52-nD040": {
    tc_name: "沙埔崗 288 號",
    en_name: "No.288 Sha Po Kong",
    lat: "22.386623",
    lon: "113.921158",
  },
  "K52-nD050": {
    tc_name: "沙埔崗 351 號",
    en_name: "No.351 Sha Po Kong",
    lat: "22.385511",
    lon: "113.921257",
  },
  "K52-nD060": {
    tc_name: "中電A廠",
    en_name: "CLP (Plant A)",
    lat: "22.38252",
    lon: "113.92102",
  },
  "K52-nD070": {
    tc_name: "紹榮鋼鐵",
    en_name: "Shiu Wing Steel Mill",
    lat: "22.37012",
    lon: "113.92898",
  },
  "K52-nD080": {
    tc_name: "環保園",
    en_name: "EcoPark",
    lat: "22.37001",
    lon: "113.93439",
  },
  "K52-nD090": {
    tc_name: "內河碼頭",
    en_name: "River Trade Terminal",
    lat: "22.36855",
    lon: "113.938063",
  },
  "K52-nD100": {
    tc_name: "政府車場",
    en_name: "Government Depot",
    lat: "22.366875",
    lon: "113.944272",
  },
  "K52-nD110": {
    tc_name: "望后石",
    en_name: "Pillar Point",
    lat: "22.368667",
    lon: "113.948837",
  },
  "K52-nD120": {
    tc_name: "蝴蝶灣公園",
    en_name: "Butterfly Beach Park",
    lat: "22.3729",
    lon: "113.954631",
  },
  "K52-nD130": {
    tc_name: "屯門公眾騎術學校",
    en_name: "Tuen Mun Public Riding School",
    lat: "22.375258",
    lon: "113.958583",
  },
  "K52-nD140": {
    tc_name: "輕鐵蝴蝶站",
    en_name: "LR Butterfly Stop",
    lat: "22.378359",
    lon: "113.961955",
    connections: {
      LR: "15",
    },
  },
  "K52-nD150": {
    tc_name: "輕鐵車廠站",
    en_name: "Light Rail Depot Stop",
    lat: "22.382203",
    lon: "113.96359",
    connections: {
      LR: "20",
    },
  },
  "K52-nD160": {
    tc_name: "輕鐵龍門站",
    en_name: "LR Lung Mun Stop",
    lat: "22.385399",
    lon: "113.965222",
    connections: {
      LR: "30",
    },
  },
  "K52-nD170": {
    tc_name: "輕鐵青雲站",
    en_name: "LR Tsing Wun Stop",
    lat: "22.393627",
    lon: "113.96752",
    connections: {
      LR: "50",
    },
  },
  "K52-nD180": {
    tc_name: "輕鐵建安站",
    en_name: "LR Kin On Stop",
    lat: "22.395064",
    lon: "113.969953",
    connections: {
      LR: "60",
    },
  },
  "K52-nD190": {
    tc_name: "屯門站",
    en_name: "Tuen Mun Station",
    lat: "22.394117",
    lon: "113.973992",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K52-nD200": {
    tc_name: "屯門市中心",
    en_name: "Tuen Mun Town Centre",
    lat: "22.391543",
    lon: "113.975435",
    connections: {
      LR: "280",
    },
  },
  "K52-nD210": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.3906",
    lon: "113.9788",
  },
  "K52-nD220": {
    tc_name: "恒順園",
    en_name: "Handsome Court",
    lat: "22.38771",
    lon: "113.9807",
  },
  "K52-nD230": {
    tc_name: "恒豐園",
    en_name: "Harvest Garden",
    lat: "22.38519",
    lon: "113.981",
  },
  "K52-nD240": {
    tc_name: "輕鐵三聖站",
    en_name: "LR Sam Shing Stop",
    lat: "22.382943",
    lon: "113.976283",
    connections: {
      LR: "920",
    },
  },
  "K52-nD250": {
    tc_name: "屯門中央廣場",
    en_name: "Tuen Mun Central Square",
    lat: "22.380902",
    lon: "113.972021",
  },
  "K52-nD260": {
    tc_name: "湖景邨 湖翠樓",
    en_name: "Wu Tsui House, Wu King Estate",
    lat: "22.37652",
    lon: "113.966372",
  },
  "K52-nD270": {
    tc_name: "兆禧苑",
    en_name: "Siu Hei Court",
    lat: "22.374598",
    lon: "113.965833",
  },
  "K52-nD280": {
    tc_name: "海翠花園",
    en_name: "Pierhead Garden",
    lat: "22.373244",
    lon: "113.965958",
  },
  "K52-nD290": {
    tc_name: "邁亞美海灣",
    en_name: "Miami Beach Towers",
    lat: "22.372843",
    lon: "113.969696",
  },
  "K52-nD300": {
    tc_name: "悅湖山莊",
    en_name: "Yuet Wu Villa",
    lat: "22.375257",
    lon: "113.968481",
  },
  // Route K52A
  "K52A-U010": {
    tc_name: "屯門站",
    en_name: "Tuen Mun Station",
    lat: "22.394225",
    lon: "113.973358",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K52A-U020": {
    tc_name: "輕鐵建安站",
    en_name: "LR Kin On Stop",
    lat: "22.394687",
    lon: "113.970746",
    connections: {
      LR: "60",
    },
  },
  "K52A-U030": {
    tc_name: "輕鐵青雲站",
    en_name: "LR Tsing Wun Stop",
    lat: "22.393382",
    lon: "113.967707",
    connections: {
      LR: "50",
    },
  },

  "K52A-U040": {
    tc_name: "聖彼得堂",
    en_name: "SKH St. Peter's Church",
    lat: "22.391722",
    lon: "113.967726",
  },
  "K52A-U050": {
    tc_name: "富健花園",
    en_name: "Glorious Garden",
    lat: "22.383618",
    lon: "113.964478",
  },
  "K52A-U060": {
    tc_name: "新屯門中心",
    en_name: "Sun Tuen Mun Centre",
    lat: "22.382269",
    lon: "113.963833",
    connections: {
      LR: "20",
    },
  },
  "K52A-U070": {
    tc_name: "輕鐵蝴蝶站",
    en_name: "LR Butterfly Stop",
    lat: "22.377547",
    lon: "113.961481",
    connections: {
      LR: "15",
    },
  },
  "K52A-U080": {
    tc_name: "屯門公眾騎術學校",
    en_name: "Tuen Mun Public Riding School",
    lat: "22.375483",
    lon: "113.959318",
  },
  "K52A-U090": {
    tc_name: "蝴蝶灣公園",
    en_name: "Butterfly Beach Park",
    lat: "22.37319",
    lon: "113.95473",
  },
  "K52A-U100": {
    tc_name: "望后石",
    en_name: "Pillar Point",
    lat: "22.368528",
    lon: "113.948898",
  },
  "K52A-U110": {
    tc_name: "政府車場",
    en_name: "Government Depot",
    lat: "22.366727",
    lon: "113.94371",
  },
  "K52A-U120": {
    tc_name: "內河碼頭",
    en_name: "River Trade Terminal",
    lat: "22.36857",
    lon: "113.93822",
  },

  "K52A-U130": {
    tc_name: "環保園",
    en_name: "EcoPark",
    lat: "22.36999",
    lon: "113.93403",
  },
  "K52A-U140": {
    tc_name: "紹榮鋼鐵",
    en_name: "Shiu Wing Steel Mill",
    lat: "22.36995",
    lon: "113.92874",
  },
  "K52A-U150": {
    tc_name: "沙埔崗 312 號",
    en_name: "No.312 Sha Po Kong",
    lat: "22.386382",
    lon: "113.921122",
  },

  "K52A-U160": {
    tc_name: "沙埔崗 177 號",
    en_name: "No.177 Sha Po Kong",
    lat: "22.388034",
    lon: "113.920786",
  },
  "K52A-U170": {
    tc_name: "沙埔崗 127 號",
    en_name: "No.127 Sha Po Kong",
    lat: "22.389307",
    lon: "113.920224",
  },
  "K52A-U180": {
    tc_name: "曾咀",
    en_name: "Tsang Tsui",
    lat: "22.420002",
    lon: "113.919644",
  },
  "K52A-D010": {
    tc_name: "曾咀",
    en_name: "Tsang Tsui",
    lat: "22.420002",
    lon: "113.919644",
  },
  "K52A-D020": {
    tc_name: "沙埔崗 127 號",
    en_name: "No.127 Sha Po Kong",
    lat: "22.389103",
    lon: "113.920301",
  },
  "K52A-D030": {
    tc_name: "沙埔崗 177 號",
    en_name: "No.177 Sha Po Kong",
    lat: "22.388058",
    lon: "113.920786",
  },
  "K52A-D040": {
    tc_name: "沙埔崗 288 號",
    en_name: "No.288 Sha Po Kong",
    lat: "22.386623",
    lon: "22.386623",
  },
  "K52A-D050": {
    tc_name: "沙埔崗 351 號",
    en_name: "No.351 Sha Po Kong",
    lat: "22.385511",
    lon: "113.921257",
  },
  "K52A-D060": {
    tc_name: "中電A廠",
    en_name: "CLP (Plant A)",
    lat: "22.38252",
    lon: "113.92102",
  },
  "K52A-D070": {
    tc_name: "紹榮鋼鐵",
    en_name: "Shiu Wing Steel Mill",
    lat: "22.37012",
    lon: "113.92898",
  },
  "K52A-D080": {
    tc_name: "環保園",
    en_name: "EcoPark",
    lat: "22.37001",
    lon: "113.93439",
  },
  "K52A-D090": {
    tc_name: "內河碼頭",
    en_name: "River Trade Terminal",
    lat: "22.36855",
    lon: "113.938063",
  },
  "K52A-D100": {
    tc_name: "政府車場",
    en_name: "Government Depot",
    lat: "22.366875",
    lon: "113.944272",
  },
  "K52A-D110": {
    tc_name: "望后石",
    en_name: "Pillar Point",
    lat: "22.368667",
    lon: "113.948837",
  },
  "K52A-D120": {
    tc_name: "蝴蝶灣公園",
    en_name: "Butterfly Beach Park",
    lat: "22.3729",
    lon: "113.954631",
  },
  "K52A-D130": {
    tc_name: "屯門公眾騎術學校",
    en_name: "Tuen Mun Public Riding School",
    lat: "22.375258",
    lon: "113.958583",
  },
  "K52A-D140": {
    tc_name: "輕鐵蝴蝶站",
    en_name: "LR Butterfly Stop",
    lat: "22.378359",
    lon: "113.961955",
    connections: {
      LR: "15",
    },
  },
  "K52A-D150": {
    tc_name: "輕鐵車廠站",
    en_name: "Light Rail Depot Stop",
    lat: "22.382203",
    lon: "113.96359",
    connections: {
      LR: "20",
    },
  },
  "K52A-D160": {
    tc_name: "輕鐵龍門站",
    en_name: "LR Lung Mun Stop",
    lat: "22.385399",
    lon: "113.965222",
    connections: {
      LR: "30",
    },
  },
  "K52A-D170": {
    tc_name: "輕鐵青雲站",
    en_name: "LR Tsing Wun Stop",
    lat: "22.393627",
    lon: "113.96752",
    connections: {
      LR: "50",
    },
  },
  "K52A-D180": {
    tc_name: "輕鐵建安站",
    en_name: "LR Kin On Stop",
    lat: "22.395064",
    lon: "113.969953",
    connections: {
      LR: "60",
    },
  },
  "K52A-D190": {
    tc_name: "屯門站",
    en_name: "Tuen Mun Station",
    lat: "22.394225",
    lon: "113.973358",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  // Route K53
  "K53-U010": {
    tc_name: "屯門站 (輕鐵屯門站)",
    en_name: "Tuen Mun Station (LR Tuen Mun Stop)",
    lat: "22.394225",
    lon: "113.973358",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K53-U020": {
    tc_name: "屯門市中心",
    en_name: "Tuen Mun Town Centre",
    lat: "22.391543",
    lon: "113.975435",
    connections: {
      LR: "280",
    },
  },
  "K53-U030": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.390622",
    lon: "113.978751",
  },
  "K53-U040": {
    tc_name: "恒順園",
    en_name: "Handsome Court",
    lat: "22.387719",
    lon: "113.980762",
  },
  "K53-U050": {
    tc_name: "恒豐園",
    en_name: "Harvest Garden",
    lat: "22.385247",
    lon: "113.981068",
  },
  "K53-U060": {
    tc_name: "三聖邨",
    en_name: "Sam Shing Estate",
    lat: "22.381732",
    lon: "113.978847",
  },
  "K53-U070": {
    tc_name: "青山灣",
    en_name: "Castle Peak Beach",
    lat: "22.378923",
    lon: "113.980763",
  },
  "K53-U080": {
    tc_name: "海景花園",
    en_name: "Seaview Garden",
    lat: "22.377877",
    lon: "113.983564",
  },
  "K53-U090": {
    tc_name: "咖啡灣",
    en_name: "Cafeteria Beach",
    lat: "22.374926",
    lon: "113.986745",
  },
  "K53-U100": {
    tc_name: "黃金泳灘",
    en_name: "Golden Beach",
    lat: "22.373785",
    lon: "113.990848",
  },
  "K53-U110": {
    tc_name: "香港黃金海岸",
    en_name: "Hong Kong Gold Coast",
    lat: "22.372048",
    lon: "113.993608",
  },
  "K53-U120": {
    tc_name: "愛琴海岸",
    en_name: "Aegean Coast",
    lat: "22.371605",
    lon: "113.9954",
  },
  "K53-U130": {
    tc_name: "掃管笏變電站",
    en_name: "So Kwun Wat Sub-station",
    lat: "22.373878",
    lon: "113.996144",
  },
  "K53-U140": {
    tc_name: "掃管笏村",
    en_name: "So Kwun Wat Tsuen",
    lat: "22.375743",
    lon: "113.999829",
  },
  "K53-D010": {
    tc_name: "掃管笏 (鄭任安夫人千禧小學)",
    en_name: "So Kwun Wat (Mrs. Cheng Yam On Millennium School)",
    lat: "22.372023",
    lon: "114.003593",
  },
  "K53-D015": {
    tc_name: "掃管笏路",
    en_name: "So Kwun Wat Road",
    lat: "22.374216",
    lon: "114.002295",
  },
  "K53-D020": {
    tc_name: "星堤",
    en_name: "Avignon",
    lat: "22.37556",
    lon: "113.9996",
  },
  "K53-D030": {
    tc_name: "管翠路",
    en_name: "Kwun Chui Road",
    lat: "22.375123",
    lon: "113.997707",
  },
  "K53-D040": {
    tc_name: "愛琴海岸",
    en_name: "Aegean Coast",
    lat: "22.371473",
    lon: "113.995381",
  },
  "K53-D050": {
    tc_name: "香港黃金海岸",
    en_name: "Hong Kong Gold Coast",
    lat: "22.371294",
    lon: "113.993906",
  },
  "K53-D060": {
    tc_name: "黃金泳灘",
    en_name: "Golden Beach",
    lat: "22.373653",
    lon: "113.991237",
  },
  "K53-D070": {
    tc_name: "咖啡灣",
    en_name: "Cafeteria Beach",
    lat: "22.375924",
    lon: "113.985662",
  },
  "K53-D080": {
    tc_name: "碧翠花園",
    en_name: "Bayview Terrace",
    lat: "22.377941",
    lon: "113.983293",
  },

  "K53-D090": {
    tc_name: "青山灣碼頭",
    en_name: "Castle Peak Bay Pier",
    lat: "22.378954",
    lon: "113.980609",
  },
  "K53-D100": {
    tc_name: "三聖邨",
    en_name: "Sam Shing Estate",
    lat: "22.381245",
    lon: "113.979119",
  },
  "K53-D110": {
    tc_name: "恆福花園 (輕鐵三聖站)",
    en_name: "Hanford Garden (LR Sam Shing Stop)",
    lat: "22.382079",
    lon: "113.977158",
    connections: {
      LR: "920",
    },
  },
  "K53-D120": {
    tc_name: "胡陳金枝中學",
    en_name: "Mrs Aw Boon Haw Secondary School",
    lat: "22.383774",
    lon: "113.97939",
  },
  "K53-D130": {
    tc_name: "青善遊樂場",
    en_name: "Tsing Sin Playground",
    lat: "22.38463",
    lon: "113.980641",
  },
  "K53-D140": {
    tc_name: "置樂花園",
    en_name: "Chi Lok Fa Yuen",
    lat: "22.387328",
    lon: "113.980668",
  },
  "K53-D150": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.390452",
    lon: "113.978855",
  },
  "K53-D160": {
    tc_name: "輕鐵市中心站",
    en_name: "LR Town Centre Stop",
    lat: "22.392116",
    lon: "113.975082",
    connections: {
      LR: "280",
    },
  },
  "K53-U011": {
    tc_name: "屯門站 (輕鐵屯門站)",
    en_name: "Tuen Mun Station (LR Tuen Mun Stop)",
    lat: "22.394225",
    lon: "113.973358",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  //Route K53S (Special Trips)
  "K53*-U010": {
    tc_name: "屯門站 (輕鐵屯門站)",
    en_name: "Tuen Mun Station (LR Tuen Mun Stop)",
    lat: "22.394225",
    lon: "113.973358",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K53*-U020": {
    tc_name: "天后路",
    en_name: "Tin Hau Road",
    lat: "22.391668",
    lon: "113.971547",
  },
  "K53*-U030": {
    tc_name: "業旺邨",
    en_name: "Yip Wong Estate",
    lat: "22.38814",
    lon: "113.97015",
  },
  "K53*-U040": {
    tc_name: "屯門站 (輕鐵屯門站)",
    en_name: "Tuen Mun Station (LR Tuen Mun Stop)",
    lat: "22.394225",
    lon: "113.973358",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  
  //Route K54
  "K54-U010": {
    tc_name: "和田邨",
    en_name: "Wo Tin Estate",
    lat: "22.4129536",
    lon: "113.9686386",
  },
  "K54-U020": {
    tc_name: "菁田邨",
    en_name: "Ching Tin Estate",
    lat: "22.4122937",
    lon: "113.9705794",
  },
  "K54-U030": {
    tc_name: "紫田村",
    en_name: "Tsz Tin Tsuen",
    lat: "22.4143948",
    lon: "113.9738808",
  },
  "K54-U040": {
    tc_name: "欣田邨",
    en_name: "Yan Tin Estate",
    lat: "22.41435",
    lon: "113.97701",
  },
  "K54-U050": {
    tc_name: "港鐵兆康站 (北) (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (North) (LR Siu Hong Stop)",
    lat: "22.4134",
    lon: "113.97902",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K54-U060": {
    tc_name: "紅橋",
    en_name: "Hung Kiu",
    lat: "22.4019965",
    lon: "113.977489",
  },
  "K54-U070": {
    tc_name: "屯門市中心",
    en_name: "Tuen Mun Town Centre",
    lat: "22.391389",
    lon: "113.975465",
    connections: {
      LR: "280",
    },
  },
  "K54-D010": {
    tc_name: "屯門市廣場",
    en_name: "Tuen Mun Town Plaza",
    lat: "22.3927298",
    lon: "113.9769618",
  },
  "K54-D020": {
    tc_name: "新墟街市",
    en_name: "San Hui Market",
    lat: "22.3989419",
    lon: "113.9766028",
  },
  "K54-D030": {
    tc_name: "港鐵兆康站 (北) (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (North) (LR Siu Hong Stop)",
    lat: "22.41357",
    lon: "113.9791",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K54-D040": {
    tc_name: "兆康苑",
    en_name: "Siu Hong Court",
    lat: "22.414907",
    lon: "113.977412",
  },
  "K54-D050": {
    tc_name: "欣寶路公共運輸交匯處",
    en_name: "Yan Po Road Public Transport Interchange",
    lat: "22.4130992",
    lon: "113.9723357",
  },
  "K54-D060": {
    tc_name: "菁田邨",
    en_name: "Ching Tin Estate",
    lat: "22.4119741",
    lon: "113.9703303",
  },
  "K54-D070": {
    tc_name: "和田邨",
    en_name: "Wo Tin Estate",
    lat: "22.4129536",
    lon: "113.9686386",
  },
  //Route K54A
  "K54A-U010": {
    tc_name: "和田邨",
    en_name: "Wo Tin Estate",
    lat: "22.4129536",
    lon: "113.9686386",
  },
  "K54A-U020": {
    tc_name: "菁田邨",
    en_name: "Ching Tin Estate",
    lat: "22.4122937",
    lon: "113.9705794",
  },
  "K54A-U030": {
    tc_name: "紫田村",
    en_name: "Tsz Tin Tsuen",
    lat: "22.4143948",
    lon: "113.9738808",
  },
  "K54A-U040": {
    tc_name: "港鐵兆康站 (北) (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (North) (LR Siu Hong Stop)",
    lat: "22.4134",
    lon: "113.97902",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K54A-D010": {
    tc_name: "港鐵兆康站 (北) (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (North) (LR Siu Hong Stop)",
    lat: "22.41357",
    lon: "113.9791",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K54A-D020": {
    tc_name: "紫田村",
    en_name: "Tsz Tin Tsuen",
    lat: "22.4143948",
    lon: "113.9738808",
  },
  "K54A-D030": {
    tc_name: "菁田邨",
    en_name: "Ching Tin Estate",
    lat: "22.4122937",
    lon: "113.9705794",
  },
  "K54A-D040": {
    tc_name: "和田邨",
    en_name: "Wo Tin Estate",
    lat: "22.4129536",
    lon: "113.9686386",
  },
  //Route K58
  "K58-U010": {
    tc_name: "富泰",
    en_name: "Fu Tai",
    lat: "22.412815",
    lon: "113.982949",
  },
  "K58-U020": {
    tc_name: "聚康山莊",
    en_name: "Beneville",
    lat: "22.412004",
    lon: "113.98378",
  },
  "K58-U023": {
    tc_name: "嶺南大學",
    en_name: "Lingnan University",
    lat: "22.41059",
    lon: "113.982387",
  },
  "K58-U026": {
    tc_name: "彩暉花園",
    en_name: "Brilliant Garden",
    lat: "22.408575",
    lon: "113.980046",
  },
  "K58-U030": {
    tc_name: "港鐵兆康站(南), (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (South), (LR Siu Hong Stop)",
    lat: "22.410247",
    lon: "113.978583",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K58-U040": {
    tc_name: "兆康苑",
    en_name: "Siu Hong Court",
    lat: "22.4137",
    lon: "113.976951",
  },
  "K58-U050": {
    tc_name: "輕鐵麒麟站",
    en_name: "LR Kei Lun Stop",
    lat: "22.41013",
    lon: "113.976505",
    connections: {
      LR: "110",
    },
  },
  "K58-U060": {
    tc_name: "屯門醫院",
    en_name: "Tuen Mun Hospital",
    lat: "22.408609",
    lon: "113.975571",
  },
  "K58-U070": {
    tc_name: "青松觀",
    en_name: "Tsing Chung Koon",
    lat: "22.406276",
    lon: "113.971935",
  },
  "K58-U080": {
    tc_name: "保良局莊啟程第二小學",
    en_name: "PLK Vicwood K T Chong No.2 Primary School",
    lat: "22.404952",
    lon: "113.968844",
    connections: {
      LR: "212",
    },
  },
  "K58-U090": {
    tc_name: "何壽基小學",
    en_name: "Ho Sau Kei Primary School",
    lat: "22.405728",
    lon: "113.967008",
  },
  "K58-U100": {
    tc_name: "良景邨",
    en_name: "Leung King Estate",
    lat: "22.407089",
    lon: "113.964247",
    connections: {
      LR: "150",
    },
  },
  "K58-U110": {
    tc_name: "輕鐵新圍站",
    en_name: "LR San Wai Stop",
    lat: "22.405394",
    lon: "113.964648",
    connections: {
      LR: "160",
    },
  },
  "K58-U120": {
    tc_name: "輕鐵石排站",
    en_name: "LR Shek Pai Stop",
    lat: "22.401886",
    lon: "113.96805",
    connections: {
      LR: "170",
    },
  },
  "K58-U130": {
    tc_name: "輕鐵鳴琴站",
    en_name: "LR Ming Kum Stop",
    lat: "22.396961",
    lon: "113.967622",
    connections: {
      LR: "200",
    },
  },
  "K58-U140": {
    tc_name: "輕鐵建安站",
    en_name: "LR Kin On Stop",
    lat: "22.395021",
    lon: "113.969976",
    connections: {
      LR: "60",
    },
  },

  "K58-U150": {
    tc_name: "港鐵屯門站",
    en_name: "MTR Tuen Mun Station",
    lat: "22.394225",
    lon: "113.973358",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K58-U160": {
    tc_name: "屯門市中心",
    en_name: "Tuen Mun Town Centre",
    lat: "22.391389",
    lon: "113.975465",
    connections: {
      LR: "280",
    },
  },
  "K58-U170": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.390652",
    lon: "113.978795",
  },
  "K58-U180": {
    tc_name: "恒順園",
    en_name: "Handsome Court",
    lat: "22.387795",
    lon: "113.980743",
  },
  "K58-U190": {
    tc_name: "恒豐園",
    en_name: "Harvest Garden",
    lat: "22.385271",
    lon: "113.981071",
  },
  "K58-U200": {
    tc_name: "三聖邨",
    en_name: "Sam Shing Estate",
    lat: "22.381705",
    lon: "113.978852",
  },
  "K58-U210": {
    tc_name: "青山灣",
    en_name: "Castle Peak Bay",
    lat: "22.379752",
    lon: "113.980639",
  },
  "K58-D010": {
    tc_name: "青山灣",
    en_name: "Castle Peak Bay",
    lat: "22.379752",
    lon: "113.980639",
  },
  "K58-D020": {
    tc_name: "三聖邨",
    en_name: "Sam Shing Estate",
    lat: "22.381189",
    lon: "113.979146",
  },
  "K58-D030": {
    tc_name: "胡陳金枝中學",
    en_name: "Mrs Aw Boon Haw Secondary School",
    lat: "22.383774",
    lon: "113.97939",
  },
  "K58-D040": {
    tc_name: "青善遊樂場",
    en_name: "Tsing Sin Playground",
    lat: "22.38458",
    lon: "113.980659",
  },
  "K58-D050": {
    tc_name: "置樂花園",
    en_name: "Chi Lok Fa Yuen",
    lat: "22.387305",
    lon: "113.980672",
  },
  "K58-D060": {
    tc_name: "屯門官立中學",
    en_name: "Tuen Mun Government Secondary School",
    lat: "22.39043",
    lon: "113.978867",
  },
  "K58-D070": {
    tc_name: "輕鐵市中心站",
    en_name: "LR Town Centre Stop",
    lat: "22.392096",
    lon: "113.97512",
    connections: {
      LR: "280",
    },
  },
  "K58-D080": {
    tc_name: "輕鐵屯門站 (港鐵屯門站)",
    en_name: "LR Tuen Mun Stop (MTR Tuen Mun Station)",
    lat: "22.39395",
    lon: "113.9737",
    connections: {
      TML: "TUM",
      LR: "295",
    },
  },
  "K58-D090": {
    tc_name: "輕鐵建安站",
    en_name: "LR Kin On Stop",
    lat: "22.394699",
    lon: "113.970762",
    connections: {
      LR: "60",
    },
  },
  "K58-D100": {
    tc_name: "輕鐵鳴琴站",
    en_name: "LR Ming Kum Stop",
    lat: "22.396769",
    lon: "113.967425",
    connections: {
      LR: "200",
    },
  },
  "K58-D110": {
    tc_name: "輕鐵石排站",
    en_name: "LR Shek Pai Stop",
    lat: "22.401983",
    lon: "113.967883",
    connections: {
      LR: "170",
    },
  },
  "K58-D120": {
    tc_name: "輕鐵新圍站",
    en_name: "LR San Wai Stop",
    lat: "22.405404",
    lon: "113.963966",
    connections: {
      LR: "160",
    },
  },
  "K58-D130": {
    tc_name: "輕鐵田景站",
    en_name: "LR Tin King Stop",
    lat: "22.407716",
    lon: "113.96598",
    connections: {
      LR: "140",
    },
  },
  "K58-D140": {
    tc_name: "青田遊樂場",
    en_name: "Tsing Tin Playground",
    lat: "22.405974",
    lon: "113.967207",
  },
  "K58-D150": {
    tc_name: "建生邨樂生樓",
    en_name: "Lok Sang House, Kin Sang Estate",
    lat: "22.405169",
    lon: "113.968901",
    connections: {
      LR: "212",
    },
  },
  "K58-D160": {
    tc_name: "建生邨泰生樓",
    en_name: "Tai Sang House, Kin Sang Estate",
    lat: "22.406394",
    lon: "113.971667",
  },
  "K58-D170": {
    tc_name: "輕鐵麒麟站",
    en_name: "LR Kei Lun Stop",
    lat: "22.411042",
    lon: "113.97648",
    connections: {
      LR: "110",
    },
  },
  "K58-D180": {
    tc_name: "欣田邨",
    en_name: "Yan Tin Estate",
    lat: "22.414291",
    lon: "113.977143",
  },
  "K58-D190": {
    tc_name: "港鐵兆康站 (南), (輕鐵兆康站)",
    en_name: "MTR Siu Hong Station (South), (LR Siu Hong Stop)",
    lat: "22.410378",
    lon: "113.978607",
    connections: {
      TML: "SIH",
      LR: "100",
    },
  },
  "K58-D193": {
    tc_name: "彩暉花園",
    en_name: "Brilliant Garden",
    lat: "22.408779",
    lon: "113.980397",
  },
  "K58-D196": {
    tc_name: "嶺南大學",
    en_name: "Lingnan University",
    lat: "22.410694",
    lon: "113.982212",
  },
  "K58-D200": {
    tc_name: "倚嶺南庭",
    en_name: "South Hillcrest",
    lat: "22.411915",
    lon: "113.983238",
  },
  "K58-D210": {
    tc_name: "富泰",
    en_name: "Fu Tai",
    lat: "22.412815",
    lon: "113.982949",
  },
  //Route K65
  "K65-U010": {
    tc_name: "元朗站 (輕鐵元朗站, 港鐵元朗站)",
    en_name: "Yuen Long Station (LR Yuen Long Stop, MTR Yuen Long Station)",
    lat: "22.44514396",
    lon: "114.035187",
    connections: {
      TML: "YUL",
      LR: "600",
    },
  },
  "K65-U020": {
    tc_name: "又新街",
    en_name: "Yau San Street",
    lat: "22.44451201",
    lon: "114.0315245",
    connections: {
      LR: "590",
    },
  },
  "K65-U030": {
    tc_name: "大棠路",
    en_name: "Tai Tong Road",
    lat: "22.4446245",
    lon: "114.028421",
    connections: {
      LR: "580",
    },
  },
  "K65-U040": {
    tc_name: "康樂路",
    en_name: "Hong Lok Road",
    lat: "22.44478103",
    lon: "114.026429",
    connections: {
      LR: "580",
    },
  },
  "K65-U050": {
    tc_name: "元朗警署",
    en_name: "Yuen Long Police Station",
    lat: "22.44449303",
    lon: "114.024142",
    connections: {
      LR: "570",
    },
  },
  "K65-U060": {
    tc_name: "輕鐵水邊圍站",
    en_name: "LR Shui Pin Wai Stop",
    lat: "22.44449303",
    lon: "114.02119",
    connections: {
      LR: "560",
    },
  },
  "K65-U070": {
    tc_name: "元朗公園",
    en_name: "Yuen Long Park",
    lat: "22.44416303",
    lon: "114.018772",
  },
  "K65-U080": {
    tc_name: "朗邊",
    en_name: "Long Bin",
    lat: "22.44347999",
    lon: "114.014914",
  },
  "K65-U090": {
    tc_name: "屏山屏興里",
    en_name: "Ping Hing Lane, Ping Shan",
    lat: "22.443597",
    lon: "114.009912",
  },
  "K65-U100": {
    tc_name: "坑尾村",
    en_name: "Hang Mei Tsuen",
    lat: "22.44378098",
    lon: "114.007739",
  },
  "K65-U110": {
    tc_name: "輕鐵坑尾村站",
    en_name: "LR Hang Mei Tsuen Stop",
    lat: "22.445754",
    lon: "114.004915",
    connections: {
      LR: "425",
    },
  },
  "K65-U120": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.44692696",
    lon: "114.003126",
    connections: {
      TML: "TIS",
    },
  },
  "K65-U130": {
    tc_name: "石埗路",
    en_name: "Shek Po Road",
    lat: "22.44667601",
    lon: "113.998121",
  },
  "K65-U140": {
    tc_name: "沙洲里村",
    en_name: "Sha Chau Lei Tsuen",
    lat: "22.44606899",
    lon: "113.995464",
  },
  "K65-U150": {
    tc_name: "廈村",
    en_name: "Ha Tsuen",
    lat: "22.44756503",
    lon: "113.9938825",
  },
  "K65-U160": {
    tc_name: "錫降圍",
    en_name: "Shek Kong Wai",
    lat: "22.44952099",
    lon: "113.994281",
  },
  "K65-U170": {
    tc_name: "羅屋村",
    en_name: "Lo Uk Tsuen",
    lat: "22.451291",
    lon: "113.994884",
  },
  "K65-U180": {
    tc_name: "東頭村 (南)",
    en_name: "Tung Tau Tsuen (South)",
    lat: "22.45294902",
    lon: "113.994668",
  },
  "K65-U190": {
    tc_name: "東頭村 (北)",
    en_name: "Tung Tau Tsuen (North)",
    lat: "22.45670102",
    lon: "113.991661",
  },
  "K65-U200": {
    tc_name: "鳳降村",
    en_name: "Fung Kong Tsuen",
    lat: "22.45909799",
    lon: "113.990368",
  },
  "K65-U210": {
    tc_name: "沙江圍",
    en_name: "Sha Kong Wai",
    lat: "22.46156302",
    lon: "113.988875",
  },
  "K65-U220": {
    tc_name: "新慶村",
    en_name: "San Hing Tsuen",
    lat: "22.46464396",
    lon: "113.986202",
  },
  "K65-U230": {
    tc_name: "流浮山",
    en_name: "Lau Fau Shan",
    lat: "22.467614",
    lon: "113.983984",
  },
  "K65-D010": {
    tc_name: "流浮山",
    en_name: "Lau Fau Shan",
    lat: "22.467614",
    lon: "113.983984",
  },
  "K65-D020": {
    tc_name: "新慶村",
    en_name: "San Hing Tsuen",
    lat: "22.46416401",
    lon: "113.986741",
  },
  "K65-D030": {
    tc_name: "沙江圍",
    en_name: "Sha Kong Wai",
    lat: "22.46140502",
    lon: "113.989344",
  },
  "K65-D040": {
    tc_name: "鳳降村",
    en_name: "Fung Kong Tsuen",
    lat: "22.45915096",
    lon: "113.990515",
  },
  "K65-D050": {
    tc_name: "東頭村",
    en_name: "Tung Tau Tsuen",
    lat: "22.45592603",
    lon: "113.992509",
  },
  "K65-D060": {
    tc_name: "羅屋村",
    en_name: "Lo Uk Tsuen",
    lat: "22.45256698",
    lon: "113.994935",
  },
  "K65-D070": {
    tc_name: "錫降圍",
    en_name: "Shek Kong Wai",
    lat: "22.44876897",
    lon: "113.994128",
  },
  "K65-D080": {
    tc_name: "廈村",
    en_name: "Ha Tsuen",
    lat: "22.44670803",
    lon: "113.994761",
  },
  "K65-D090": {
    tc_name: "沙洲里村",
    en_name: "Sha Chau Lei Tsuen",
    lat: "22.44663703",
    lon: "113.997152",
  },
  "K65-D100": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.44694096",
    lon: "114.00282",
    connections: {
      TML: "TIS",
    },
  },
  "K65-D110": {
    tc_name: "輕鐵坑尾村站",
    en_name: "LR Hang Mei Tsuen Stop",
    lat: "22.44588903",
    lon: "114.00512",
    connections: {
      LR: "425",
    },
  },
  "K65-D120": {
    tc_name: "坑尾村",
    en_name: "Hang Mei Tsuen",
    lat: "22.44390302",
    lon: "114.007678",
  },
  "K65-D130": {
    tc_name: "屏山屏興里",
    en_name: "Ping Hing Lane, Ping Shan",
    lat: "22.44370999",
    lon: "114.010233",
  },
  "K65-D140": {
    tc_name: "輕鐵屏山站",
    en_name: "LR Ping Shan Stop",
    lat: "22.44322099",
    lon: "114.012915",
    connections: {
      LR: "400",
    },
  },
  "K65-D150": {
    tc_name: "輕鐵水邊圍站",
    en_name: "LR Shui Pin Wai Stop",
    lat: "22.44457601",
    lon: "114.019733",
    connections: {
      LR: "560",
    },
  },
  "K65-D160": {
    tc_name: "元朗廣場",
    en_name: "Yuen Long Plaza",
    lat: "22.44457601",
    lon: "114.023787",
    connections: {
      LR: "570",
    },
  },
  "K65-D170": {
    tc_name: "開心廣場",
    en_name: "Yuen Long Landmark",
    lat: "22.44446897",
    lon: "114.02828",
    connections: {
      LR: "590",
    },
  },
  "K65-D180": {
    tc_name: "谷亭街",
    en_name: "Kuk Ting Street",
    lat: "22.44441197",
    lon: "114.030327",
    connections: {
      LR: "590",
    },
  },
  "K65-D190": {
    tc_name: "元朗站 (輕鐵元朗站, 港鐵元朗站)",
    en_name: "Yuen Long Station (LR Yuen Long Stop, MTR Yuen Long Station)",
    lat: "22.44514396",
    lon: "114.035187",
    connections: {
      TML: "YUL",
      LR: "600",
    },
  },

  //route K65A
  "K65A-U010": {
    tc_name: "天水圍站 (輕鐵天水圍站)",
    en_name: "Tin Shui Wai Station (LR Tin Shui Wai Stop)",
    lat: "22.44654",
    lon: "114.0037516",
    connections: {
      LR: "430",
    },
  },
  "K65A-U020": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.44692696",
    lon: "114.003126",
    connections: {
      TML: "TIS",
    },
  },
  "K65A-U030": {
    tc_name: "石埗路",
    en_name: "Shek Po Road",
    lat: "22.44667601",
    lon: "113.998121",
  },
  "K65A-U040": {
    tc_name: "沙洲里村",
    en_name: "Sha Chau Lei Tsuen",
    lat: "22.44606899",
    lon: "113.995464",
  },
  "K65A-U050": {
    tc_name: "廈村",
    en_name: "Ha Tsuen",
    lat: "22.44756503",
    lon: "113.9938825",
  },
  "K65A-U060": {
    tc_name: "錫降圍",
    en_name: "Shek Kong Wai",
    lat: "22.44952099",
    lon: "113.994281",
  },
  "K65A-U070": {
    tc_name: "羅屋村",
    en_name: "Lo Uk Tsuen",
    lat: "22.451291",
    lon: "113.994884",
  },
  "K65A-U080": {
    tc_name: "東頭村 (南)",
    en_name: "Tung Tau Tsuen (South)",
    lat: "22.45294902",
    lon: "113.994668",
  },
  "K65A-U090": {
    tc_name: "東頭村 (北)",
    en_name: "Tung Tau Tsuen (North)",
    lat: "22.45670102",
    lon: "113.991661",
  },
  "K65A-U100": {
    tc_name: "鳳降村",
    en_name: "Fung Kong Tsuen",
    lat: "22.459098",
    lon: "113.990368",
  },
  "K65A-U110": {
    tc_name: "沙江圍",
    en_name: "Sha Kong Wai",
    lat: "22.46156302",
    lon: "113.988875",
  },
  "K65A-U120": {
    tc_name: "新慶村",
    en_name: "San Hing Tsuen",
    lat: "22.46464396",
    lon: "113.986202",
  },
  "K65A-U130": {
    tc_name: "流浮山",
    en_name: "Lau Fau Shan",
    lat: "22.467614",
    lon: "113.983984",
  },
  "K65A-D010": {
    tc_name: "流浮山",
    en_name: "Lau Fau Shan",
    lat: "22.467614",
    lon: "113.983984",
  },
  "K65A-D020": {
    tc_name: "新慶村",
    en_name: "San Hing Tsuen",
    lat: "22.46416401",
    lon: "113.986741",
  },
  "K65A-D030": {
    tc_name: "沙江圍",
    en_name: "Sha Kong Wai",
    lat: "22.46140502",
    lon: "113.989344",
  },
  "K65A-D040": {
    tc_name: "鳳降村",
    en_name: "Fung Kong Tsuen",
    lat: "22.45915096",
    lon: "113.990515",
  },
  "K65A-D050": {
    tc_name: "東頭村",
    en_name: "Tung Tau Tsuen",
    lat: "22.45592603",
    lon: "113.992509",
  },
  "K65A-D060": {
    tc_name: "羅屋村",
    en_name: "Lo Uk Tsuen",
    lat: "22.45256698",
    lon: "113.994935",
  },
  "K65A-D070": {
    tc_name: "錫降圍",
    en_name: "Shek Kong Wai",
    lat: "22.44876897",
    lon: "113.994128",
  },
  "K65A-D080": {
    tc_name: "廈村",
    en_name: "Ha Tsuen",
    lat: "22.44670803",
    lon: "113.994761",
  },
  "K65A-D090": {
    tc_name: "沙洲里村",
    en_name: "Sha Chau Lei Tsuen",
    lat: "22.44663703",
    lon: "113.997152",
  },
  "K65A-D100": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.44694096",
    lon: "114.00282",
    connections: {
      TML: "TIS",
    },
  },
  "K65A-D110": {
    tc_name: "天水圍站 (輕鐵天水圍站)",
    en_name: "Tin Shui Wai Station (LR Tin Shui Wai Stop)",
    lat: "22.44654",
    lon: "114.0037516",
    connections: {
      LR: "430",
    },
  },
  //Route K66
  "K66-U010": {
    tc_name: "朗屏",
    en_name: "Long Ping",
    lat: "22.45078121",
    lon: "114.0229286",
  },
  "K66-U020": {
    tc_name: "楊屋村",
    en_name: "Yeung Uk Tsuen",
    lat: "22.45134693",
    lon: "114.0254022",
  },
  "K66-U030": {
    tc_name: "屏昌徑 (港鐵朗屏站)",
    en_name: "Ping Cheong Path (MTR Long Ping Station)",
    lat: "22.447672",
    lon: "114.023295",
    connections: {
      TML: "LOP",
    },
  },
  "K66-U040": {
    tc_name: "元朗盲人安老院",
    en_name: "Yuen Long Home for the Aged Blind",
    lat: "22.446002",
    lon: "114.022607",
  },
  "K66-U050": {
    tc_name: "元朗大會堂 (輕鐵豐年路站)",
    en_name: "Yuen Long Town Hall (LR Fung Nin Road Stop)",
    lat: "22.4434668",
    lon: "114.0223167",
    connections: {
      LR: "570",
    },
  },
  "K66-U060": {
    tc_name: "安康路",
    en_name: "On Hong Road",
    lat: "22.44306167",
    lon: "114.0236577",
  },
  "K66-U070": {
    tc_name: "元朗商業中心",
    en_name: "Yuen Long Commercial Centre",
    lat: "22.44297",
    lon: "114.027754",
  },
  "K66-U080": {
    tc_name: "富達廣場",
    en_name: "Manhattan Plaza",
    lat: "22.44120404",
    lon: "114.0294022",
  },
  "K66-U090": {
    tc_name: "蝶翠峰",
    en_name: "Sereno Verde",
    lat: "22.436903",
    lon: "114.029411",
  },
  "K66-U100": {
    tc_name: "禮修村",
    en_name: "Fraser Village",
    lat: "22.435406",
    lon: "114.0287683",
  },
  "K66-U110": {
    tc_name: "深涌村",
    en_name: "Sham Chung Tsuen",
    lat: "22.43369688",
    lon: "114.0285876",
  },
  "K66-U120": {
    tc_name: "羅家園",
    en_name: "Law Ka Yuen",
    lat: "22.43240032",
    lon: "114.0285171",
  },
  "K66-U130": {
    tc_name: "崇正公立學校",
    en_name: "Shung Ching School",
    lat: "22.42978906",
    lon: "114.0286105",
  },
  "K66-U140": {
    tc_name: "崇正菜站",
    en_name: "Shung Ching Vegetable Market",
    lat: "22.42739559",
    lon: "114.0295088",
  },
  "K66-U150": {
    tc_name: "老圍",
    en_name: "Lo Wai",
    lat: "22.42562276",
    lon: "114.0312735",
  },
  "K66-U160": {
    tc_name: "振華花園",
    en_name: "Chun Wah Villas",
    lat: "22.42356303",
    lon: "114.0321846",
  },
  "K66-U170": {
    tc_name: "南坑排",
    en_name: "Nam Hang Pai",
    lat: "22.42265522",
    lon: "114.0308948",
  },
  "K66-U180": {
    tc_name: "水蕉新村",
    en_name: "Shui Chiu San Tsuen",
    lat: "22.42247664",
    lon: "114.0298802",
  },
  "K66-U190": {
    tc_name: "華苑",
    en_name: "Wah Yuen",
    lat: "22.42193919",
    lon: "114.0282615",
  },
  "K66-U200": {
    tc_name: "大棠迴旋處",
    en_name: "Tai Tong Roundabout",
    lat: "22.41836575",
    lon: "114.0256553",
  },
  "K66-U210": {
    tc_name: "大棠山路",
    en_name: "Tai Tong Shan Road",
    lat: "22.41618728",
    lon: "114.0236994",
  },
  "K66-U220": {
    tc_name: "大棠黃泥墩村",
    en_name: "Tai Tong Wong Nai Tun Tsuen",
    lat: "22.416389",
    lon: "114.021874",
  },
  "K66-D010": {
    tc_name: "大棠黃泥墩村",
    en_name: "Tai Tong Wong Nai Tun Tsuen",
    lat: "22.416389",
    lon: "114.021874",
  },
  "K66-D020": {
    tc_name: "大棠山路",
    en_name: "Tai Tong Shan Road",
    lat: "22.41620604",
    lon: "114.0238973",
  },
  "K66-D030": {
    tc_name: "大棠迴旋處",
    en_name: "Tai Tong Roundabout",
    lat: "22.418334",
    lon: "114.02484",
  },
  "K66-D040": {
    tc_name: "華苑",
    en_name: "Wah Yuen",
    lat: "22.42207521",
    lon: "114.0283849",
  },
  "K66-D050": {
    tc_name: "水蕉新村",
    en_name: "Shui Chiu San Tsuen",
    lat: "22.42253674",
    lon: "114.0299286",
  },
  "K66-D060": {
    tc_name: "南坑排",
    en_name: "Nam Hang Pai",
    lat: "22.42270841",
    lon: "114.0310276",
  },
  "K66-D070": {
    tc_name: "南坑村",
    en_name: "Nam Hang Tsuen",
    lat: "22.42418205",
    lon: "114.0322333",
  },
  "K66-D080": {
    tc_name: "紅棗田村",
    en_name: "Hung Tso Tin Tsuen",
    lat: "22.42571102",
    lon: "114.0311155",
  },
  "K66-D090": {
    tc_name: "普盛圍",
    en_name: "Po Shing Wai",
    lat: "22.42751631",
    lon: "114.0293547",
  },
  "K66-D100": {
    tc_name: "崇正公立學校",
    en_name: "Shung Ching School",
    lat: "22.42993918",
    lon: "114.0285687",
  },
  "K66-D110": {
    tc_name: "羅家園",
    en_name: "Law Ka Yuen",
    lat: "22.4321724",
    lon: "114.0284926",
  },
  "K66-D120": {
    tc_name: "深涌村",
    en_name: "Sham Chung Tsuen",
    lat: "22.43377173",
    lon: "114.0285624",
  },
  "K66-D130": {
    tc_name: "禮修村",
    en_name: "Fraser Village",
    lat: "22.43543081",
    lon: "114.0287164",
  },
  "K66-D140": {
    tc_name: "蝶翠峰",
    en_name: "Sereno Verde",
    lat: "22.43724051",
    lon: "114.0295783",
  },
  "K66-D150": {
    tc_name: "恆香製餅廠",
    en_name: "Hang Heung Cake Shop",
    lat: "22.43836882",
    lon: "114.0294482",
  },
  "K66-D160": {
    tc_name: "富達廣場",
    en_name: "Manhattan Plaza",
    lat: "22.44119428",
    lon: "114.0293385",
  },
  "K66-D170": {
    tc_name: "千色廣場",
    en_name: "Citi Mall",
    lat: "22.44298197",
    lon: "114.0278032",
  },
  "K66-D180": {
    tc_name: "安康路",
    en_name: "On Hong Road",
    lat: "22.44302568",
    lon: "114.0230108",
  },
  "K66-D190": {
    tc_name: "元朗大會堂 (輕鐵豐年路站)",
    en_name: "Yuen Long Town Hall (LR Fung Nin Road Stop)",
    lat: "22.44362078",
    lon: "114.0222338",
    connections: {
      LR: "570",
    },
  },
  "K66-D200": {
    tc_name: "水邊圍邨康水樓",
    en_name: "Hong Shui House, Shui Pin Wai Estate",
    lat: "22.44613943",
    lon: "114.0213445",
  },
  "K66-D210": {
    tc_name: "朗屏邨悅屏樓 (港鐵朗屏站)",
    en_name: "Yuet Ping House, Long Ping Estate (MTR Long Ping Station)",
    lat: "22.44785153",
    lon: "114.0227269",
    connections: {
      TML: "LOP",
    },
  },
  "K66-D220": {
    tc_name: "惠州學校",
    en_name: "Wai Chow School",
    lat: "22.449515",
    lon: "22.449515",
  },
  "K66-D230": {
    tc_name: "朗屏邨珠屏樓",
    en_name: "Chu Ping House, Long Ping Estate",
    lat: "22.451414",
    lon: "114.025334",
  },
  "K66-D240": {
    tc_name: "朗屏",
    en_name: "Long Ping",
    lat: "22.45078121",
    lon: "114.0229286",
  },
  // Route K68
  "K68-U010": {
    tc_name: "元朗工業邨",
    en_name: "Yuen Long Industrial Estate",
    lat: "22.460827",
    lon: "114.026513",
  },
  "K68-U020": {
    tc_name: "凸版資訊卡",
    en_name: "Toppan Forms Card Tech Ltd",
    lat: "22.462075",
    lon: "114.028979",
  },
  "K68-U030": {
    tc_name: "雀巢",
    en_name: "Nestle (HK) Ltd",
    lat: "22.463753",
    lon: "114.027581",
  },
  "K68-U040": {
    tc_name: "元朗污水處理廠",
    en_name: "Yuen Long Sewage Treatment Works",
    lat: "22.465525",
    lon: "114.026843",
  },
  "K68-U050": {
    tc_name: "位元堂藥業大廈",
    en_name: "Wai Yuen Tong Medicine Building",
    lat: "22.464754",
    lon: "114.024822",
  },
  "K68-U060": {
    tc_name: "東電化電子零件",
    en_name: "TDK Manufacturing (HK) Co Ltd",
    lat: "22.462219",
    lon: "114.023448",
  },
  "K68-U070": {
    tc_name: "凸版印刷",
    en_name: "Toppan Printing Co (HK) Ltd",
    lat: "22.46039",
    lon: "114.022169",
  },
  "K68-U080": {
    tc_name: "匯泉國際實業",
    en_name: "Telford International Industries Ltd",
    lat: "22.45845",
    lon: "114.023157",
  },
  "K68-U090": {
    tc_name: "橫洲福慶村",
    en_name: "Wang Chau Fuk Hing Tsuen",
    lat: "22.455119",
    lon: "114.024092",
  },
  "K68-U100": {
    tc_name: "朗屏 (巴士總站)",
    en_name: "Long Ping (Bus Terminus)",
    lat: "22.45078121",
    lon: "114.0229286",
  },
  "K68-U110": {
    tc_name: "楊屋村",
    en_name: "Yeung Uk Tsuen",
    lat: "22.451379",
    lon: "114.025576",
  },
  "K68-U120": {
    tc_name: "屏昌徑 (港鐵朗屏站)",
    en_name: "Ping Cheong Path (MTR Long Ping Station)",
    lat: "22.447648",
    lon: "114.023001",
    connections: {
      TML: "LOP",
    },
  },
  "K68-U130": {
    tc_name: "元朗盲人安老院",
    en_name: "Yuen Long Home for the Aged Blind",
    lat: "22.446002",
    lon: "114.022607",
  },
  "K68-U140": {
    tc_name: "聿修堂 (輕鐵豐年路站)",
    en_name: "Lut Sau Hall (LR Fung Nin Road Stop)",
    lat: "22.442588",
    lon: "114.022245",
    connections: {
      LR: "570",
    },
  },
  "K68-U150": {
    tc_name: "元朗劇院",
    en_name: "Yuen Long Theatre",
    lat: "22.441306",
    lon: "114.02224",
  },
  "K68-U160": {
    tc_name: "銀田花園",
    en_name: "Silver Field Garden",
    lat: "22.43953",
    lon: "114.02226",
  },
  "K68-U170": {
    tc_name: "南元朗官立小學",
    en_name: "South Yuen Long Government Primary School",
    lat: "22.438801",
    lon: "114.02024",
  },
  "K68-D010": {
    tc_name: "元朗公園",
    en_name: "Yuen Long Park",
    lat: "22.44193",
    lon: "114.02007",
  },
  "K68-D020": {
    tc_name: "御豪山莊",
    en_name: "Park Royale",
    lat: "22.442503",
    lon: "114.017663",
  },
  "K68-D030": {
    tc_name: "藝典居",
    en_name: "Villa Art Deco",
    lat: "22.440088",
    lon: "114.019048",
  },
  "K68-D040": {
    tc_name: "御庭居",
    en_name: "Springdale Villas",
    lat: "22.440407",
    lon: "114.021312",
  },
  "K68-D050": {
    tc_name: "元朗游泳池",
    en_name: "Yuen Long Swimming Pool",
    lat: "22.44149722",
    lon: "114.0221389",
  },
  "K68-D060": {
    tc_name: "元朗大會堂",
    en_name: "Yuen Long Town Hall",
    lat: "22.443644",
    lon: "114.022164",
  },
  "K68-D070": {
    tc_name: "元朗廣場 (輕鐵豐年路站)",
    en_name: "Yuen Long Plaza (LR Fung Nin Road Stop)",
    lat: "22.444676",
    lon: "114.023705",
    connections: {
      LR: "570",
    },
  },
  "K68-D080": {
    tc_name: "元朗安寧路",
    en_name: "Yuen Long On Ning Road",
    lat: "22.446157",
    lon: "114.026583",
  },
  "K68-D090": {
    tc_name: "大橋村 (港鐵朗屏站)",
    en_name: "Tai Kiu Tsuen (MTR Long Ping Station)",
    lat: "22.447538",
    lon: "114.026826",
    connections: {
      TML: "LOP",
    },
  },
  "K68-D100": {
    tc_name: "惠州學校",
    en_name: "Wai Chow School",
    lat: "22.449497",
    lon: "114.025532",
  },
  "K68-D110": {
    tc_name: "朗屏邨珠屏樓",
    en_name: "Chu Ping House, Long Ping Estate",
    lat: "22.451434",
    lon: "114.025324",
  },
  "K68-D120": {
    tc_name: "朗屏 (巴士總站)",
    en_name: "Long Ping (Bus Terminus)",
    lat: "22.45078121",
    lon: "114.0229286",
  },
  "K68-D130": {
    tc_name: "橫洲福慶村",
    en_name: "Wang Chau Fuk Hing Tsuen",
    lat: "22.455166",
    lon: "114.02403",
  },
  "K68-D140": {
    tc_name: "元朗紡織品",
    en_name: "Yuen Long Textile Co Ltd",
    lat: "22.45789",
    lon: "114.023353",
  },
  "K68-D150": {
    tc_name: "大昌行食品加工及物流中心",
    en_name: "DCH Food Processing & Logistics Centre",
    lat: "22.460236",
    lon: "114.022242",
  },
  "K68-D160": {
    tc_name: "有生鉛水(熱浸鋅)",
    en_name: "Yau Sang Galvanizers (Hot-Dip) Co Ltd",
    lat: "22.462306",
    lon: "114.023412",
  },
  "K68-D170": {
    tc_name: "余仁生中心",
    en_name: "Eu Yan Sang Centre",
    lat: "22.464968",
    lon: "114.024783",
  },
  "K68-D180": {
    tc_name: "元朗污水處理廠",
    en_name: "Yuen Long Sewage Treatment Works",
    lat: "22.465479",
    lon: "114.026899",
  },
  "K68-D190": {
    tc_name: "雀巢",
    en_name: "Nestle (HK) Ltd",
    lat: "22.463782",
    lon: "114.027638",
  },
  "K68-D200": {
    tc_name: "牛尾香港",
    en_name: "Ushio HK Ltd",
    lat: "22.461655",
    lon: "114.029313",
  },
  "K68-U011": {
    tc_name: "元朗工業邨",
    en_name: "Yuen Long Industrial Estate",
    lat: "22.460827",
    lon: "114.026513",
  },
  //Route K73
  "K73-U010": {
    tc_name: "天恆",
    en_name: "Tin Heng",
    lat: "22.469006",
    lon: "113.999661",
  },
  "K73-U020": {
    tc_name: "天逸邨逸潭樓",
    en_name: "Yat Tam House, Tin Yat Estate",
    lat: "22.468098",
    lon: "113.999163",
    connections: {
      LR: "550",
    },
  },
  "K73-U030": {
    tc_name: "天逸邨逸洋樓",
    en_name: "Yat Yeung House, Tin Yat Estate",
    lat: "22.465511",
    lon: "114.00016",
  },
  "K73-U040": {
    tc_name: "天晴邨晴碧樓",
    en_name: "Ching Pik House, Tin Ching Estate",
    lat: "22.464482",
    lon: "114.003129",
  },
  "K73-U050": {
    tc_name: "香港青年協會李兆基書院",
    en_name: "HKFYG Lee Shau Kee College",
    lat: "22.463253",
    lon: "114.004136",
  },
  "K73-U060": {
    tc_name: "天葵路美湖居",
    en_name: "Maywood Court, Tin Kwai Road",
    lat: "22.46082",
    lon: "114.004565",
  },
  "K73-U070": {
    tc_name: "天城路景湖居",
    en_name: "Kenswood Court, Tin Shing Road",
    lat: "22.457444",
    lon: "114.005577",
    connections: {
      LR: "455",
    },
  },
  "K73-U080": {
    tc_name: "天慈邨",
    en_name: "Tin Tsz Estate",
    lat: "22.453279",
    lon: "114.006118",
    connections: {
      LR: "435",
    },
  },
  "K73-U090": {
    tc_name: "鳳池村",
    en_name: "Fung Chi Tsuen",
    lat: "22.44845",
    lon: "114.018634",
  },
  "K73-U100": {
    tc_name: "朗屏 (巴士總站)",
    en_name: "Long Ping (Bus Terminus)",
    lat: "22.45078121",
    lon: "114.0229286",
  },
  "K73-U110": {
    tc_name: "元朗盲人安老院",
    en_name: "Yuen Long Home for the Aged Blind",
    lat: "22.446002",
    lon: "114.022607",
  },
  "K73-U120": {
    tc_name: "元朗西 (輕鐵豐年路站)",
    en_name: "Yuen Long West (LR Fung Nin Road Stop)",
    lat: "22.445181",
    lon: "114.024919",
    connections: {
      LR: "570",
    },
  },
  "K73-D010": {
    tc_name: "元朗西 (輕鐵豐年路站)",
    en_name: "Yuen Long West (LR Fung Nin Road Stop)",
    lat: "22.445181",
    lon: "114.024919",
    connections: {
      LR: "570",
    },
  },
  "K73-D020": {
    tc_name: "元朗安寧路",
    en_name: "Yuen Long On Ning Road",
    lat: "22.446162",
    lon: "114.026731",
  },
  "K73-D030": {
    tc_name: "大橋村 (港鐵朗屏站)",
    en_name: "Tai Kiu Tsuen (MTR Long Ping Station)",
    lat: "22.447489",
    lon: "114.026856",
    connections: {
      TML: "LOP",
    },
  },
  "K73-D040": {
    tc_name: "惠州學校",
    en_name: "Wai Chow School",
    lat: "22.449497",
    lon: "114.02552",
  },
  "K73-D050": {
    tc_name: "朗屏邨珠屏樓",
    en_name: "Chu Ping House, Long Ping Estate",
    lat: "22.451408",
    lon: "114.025329",
  },
  "K73-D060": {
    tc_name: "東莞學校",
    en_name: "Tung Koon Primary School",
    lat: "22.452066",
    lon: "114.023275",
  },
  "K73-D070": {
    tc_name: "朗屏 (巴士總站)",
    en_name: "Long Ping (Bus Terminus)",
    lat: "22.45078121",
    lon: "114.0229286",
  },
  "K73-D080": {
    tc_name: "鳳池村",
    en_name: "Fung Chi Tsuen",
    lat: "22.448299",
    lon: "114.018562",
  },
  "K73-D090": {
    tc_name: "輕鐵天慈站",
    en_name: "LR Tin Tsz Stop",
    lat: "22.453358",
    lon: "114.00589",
    connections: {
      LR: "435",
    },
  },
  "K73-D100": {
    tc_name: "天水圍游泳池",
    en_name: "Tin Shui Wai Swimming Pool",
    lat: "22.455038",
    lon: "114.007159",
  },
  "K73-D110": {
    tc_name: "天龍路景湖居",
    en_name: "Kenswood Court, Tin Lung Road",
    lat: "22.458987",
    lon: "114.005282",
  },
  "K73-D120": {
    tc_name: "天葵路麗湖居",
    en_name: "Lynwood Court, Tin Kwai Road",
    lat: "22.460486",
    lon: "114.004634",
  },
  "K73-D130": {
    tc_name: "天晴邨晴雲樓",
    en_name: "Ching Wan House, Tin Ching Estate",
    lat: "22.463375",
    lon: "114.00392",
  },
  "K73-D140": {
    tc_name: "天富苑能富閣",
    en_name: "Nang Fu House, Tin Fu Court",
    lat: "22.465398",
    lon: "114.000072",
  },
  "K73-D150": {
    tc_name: "天澤邨",
    en_name: "Tin Chak Estate",
    lat: "22.468127",
    lon: "113.999183",
    connections: {
      LR: "550",
    },
  },
  "K73-D160": {
    tc_name: "天恆",
    en_name: "Tin Heng",
    lat: "22.469006",
    lon: "113.999661",
  },
  //Route K74
  "K74-U001": {
    tc_name: "天水圍市中心",
    en_name: "Tin Shui Wai Town Centre",
    lat: "22.458553",
    lon: "114.001415",
  },
  "K74-U004": {
    tc_name: "天頌苑頌棋閣",
    en_name: "Chung Ki House Tin Chung Court",
    lat: "22.461849",
    lon: "114.000382",
  },
  "K74-U007": {
    tc_name: "天頌苑",
    en_name: "Tin Chung Court",
    lat: "22.460735",
    lon: "113.997158",
  },
  "K74-U010": {
    tc_name: "天瑞",
    en_name: "Tin Shui",
    lat: "22.455322",
    lon: "113.998689",
    connections: {
      LR: "460",
    },
  },
  "K74-U020": {
    tc_name: "天水圍公園",
    en_name: "Tin Shui Wai Park",
    lat: "22.454452",
    lon: "114.003146",
  },
  "K74-U030": {
    tc_name: "天慈邨",
    en_name: "Tin Tsz Estate",
    lat: "22.453288",
    lon: "114.006135",
    connections: {
      LR: "435",
    },
  },
  "K74-U040": {
    tc_name: "鳳池村",
    en_name: "Fung Chi Tsuen",
    lat: "22.448467",
    lon: "114.018601",
  },
  "K74-U050": {
    tc_name: "朗屏 (巴士總站)",
    en_name: "Long Ping (Bus Terminus)",
    lat: "22.450549",
    lon: "114.022688",
  },
  "K74-U060": {
    tc_name: "元朗盲人安老院",
    en_name: "Yuen Long Home for the Aged Blind",
    lat: "22.445968",
    lon: "114.022572",
  },
  "K74-U070": {
    tc_name: "元朗廣場 (輕鐵豐年路站)",
    en_name: "Yuen Long Plaza (LR Fung Nin Road Stop)",
    lat: "22.44467",
    lon: "114.023718",
    connections: {
      LR: "570",
    },
  },
  "K74-U080": {
    tc_name: "開心廣場",
    en_name: "Yuen Long Landmark",
    lat: "22.4444",
    lon: "114.02836",
    connections: {
      LR: "590",
    },
  },
  "K74-U090": {
    tc_name: "港鐵元朗站(朗日路) (港鐵元朗站)",
    en_name: "MTR Yuen Long Station (Long Yat Road) (MTR Yuen Long Station)",
    lat: "22.446625",
    lon: "114.0349444",
    connections: {
      TML: "YUL",
      LR: "600",
    },
  },
  "K74-U100": {
    tc_name: "博愛醫院",
    en_name: "Pok Oi Hospital",
    lat: "22.444787",
    lon: "114.040379",
  },
  "K74-D010": {
    tc_name: "東成里",
    en_name: "Tung Shing Lei",
    lat: "22.44436944",
    lon: "114.0436667",
  },
  "K74-D020": {
    tc_name: "東華三院馬振玉中學(近朗善邨)",
    en_name: "TWGHs C.Y.Ma Memorial College (near Long Shin Estate)",
    lat: "22.44403889",
    lon: "114.0439444",
  },
  "K74-D030": {
    tc_name: "大橋村 (港鐵朗屏站)",
    en_name: "Tai Kiu Tsuen (MTR Long Ping Station)",
    lat: "22.447487",
    lon: "114.026853",
    connections: {
      TML: "LOP",
    },
  },
  "K74-D040": {
    tc_name: "惠州學校",
    en_name: "Wai Chow School",
    lat: "22.449502",
    lon: "114.025527",
  },
  "K74-D050": {
    tc_name: "朗屏邨珠屏樓",
    en_name: "Chu Ping House, Long Ping Estate",
    lat: "22.451421",
    lon: "114.025317",
  },
  "K74-D060": {
    tc_name: "朗屏 (巴士總站)",
    en_name: "Long Ping (Bus Terminus)",
    lat: "22.450549",
    lon: "114.022688",
  },
  "K74-D070": {
    tc_name: "鳳池村",
    en_name: "Fung Chi Tsuen",
    lat: "22.448256",
    lon: "114.018583",
  },
  "K74-D080": {
    tc_name: "輕鐵天慈站",
    en_name: "LR Tin Tsz Stop",
    lat: "22.45321",
    lon: "114.005918",
    connections: {
      LR: "435",
    },
  },
  "K74-D090": {
    tc_name: "天水圍公園",
    en_name: "Tin Shui Wai Park",
    lat: "22.454616",
    lon: "114.002637",
  },
  "K74-U011": {
    tc_name: "天瑞",
    en_name: "Tin Shui",
    lat: "22.455322",
    lon: "113.998689",
    connections: {
      LR: "460",
    },
  },
  "K74-D100": {
    tc_name: "天華邨",
    en_name: "Tin Wah Estate",
    lat: "22.460285",
    lon: "113.997021",
  },
  "K74-D110": {
    tc_name: "天悅邨",
    en_name: "Tin Yuet Estate",
    lat: "22.462123",
    lon: "113.99909",
  },
  "K74-U002": {
    tc_name: "天水圍市中心",
    en_name: "Tin Shui Wai Town Centre",
    lat: "22.458553",
    lon: "114.001415",
  },

  //Route K75A
  "K75A-U010": {
    tc_name: "天水圍站 (輕鐵天水圍站)",
    en_name: "Tin Shui Wai Station (LR Tin Shui Wai Stop)",
    lat: "22.44654",
    lon: "114.0037516",
    connections: {
      LR: "430",
    },
  },
  "K75A-U020": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.446839",
    lon: "114.00307",
    connections: {
      TML: "TIS",
    },
  },
  "K75A-U030": {
    tc_name: "石埗村",
    en_name: "Shek Po Tsuen",
    lat: "22.440307",
    lon: "113.998965",
  },
  "K75A-D010": {
    tc_name: "輕鐵洪水橋站",
    en_name: "LR Hung Shui Kiu Stop",
    lat: "22.433489",
    lon: "113.99772",
    connections: {
      LR: "380",
    },
  },
  "K75A-D020": {
    tc_name: "鄉事委員會",
    en_name: "Rural Committee",
    lat: "22.432897",
    lon: "113.992837",
  },
  "K75A-D030": {
    tc_name: "田心",
    en_name: "Tin Sam",
    lat: "22.434526",
    lon: "113.992613",
  },
  "K75A-D040": {
    tc_name: "新李屋村",
    en_name: "San Lee Uk Tsuen",
    lat: "22.436504",
    lon: "113.991851",
  },
  "K75A-D050": {
    tc_name: "新生村",
    en_name: "San Sang Tsuen",
    lat: "22.439615",
    lon: "113.991583",
  },
  "K75A-D060": {
    tc_name: "李屋村",
    en_name: "Lee Uk Tsuen",
    lat: "22.443545",
    lon: "113.991309",
  },
  "K75A-D070": {
    tc_name: "新屋村",
    en_name: "San Uk Tsuen",
    lat: "22.445107",
    lon: "113.992349",
  },
  "K75A-D080": {
    tc_name: "廈村市",
    en_name: "Ha Tsuen Shi",
    lat: "22.446257",
    lon: "113.993342",
  },
  "K75A-D090": {
    tc_name: "廈村",
    en_name: "Ha Tsuen",
    lat: "22.44670803",
    lon: "113.994761",
  },
  "K75A-D100": {
    tc_name: "沙洲里村",
    en_name: "Sha Chau Lei Tsuen",
    lat: "22.44663703",
    lon: "113.997152",
  },
  "K75A-D110": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.446928",
    lon: "114.002891",
    connections: {
      TML: "TIS",
    },
  },
  "K75A-U011": {
    tc_name: "天水圍站 (輕鐵天水圍站)",
    en_name: "Tin Shui Wai Station (LR Tin Shui Wai Stop)",
    lat: "22.44654",
    lon: "114.0037516",
    connections: {
      LR: "430",
    },
  },
  //Route K75P
  "K75P-U010": {
    tc_name: "天瑞",
    en_name: "Tin Shui",
    lat: "22.455356",
    lon: "113.998975",
    connections: {
      LR: "460",
    },
  },
  "K75P-U020": {
    tc_name: "天水圍公園",
    en_name: "Tin Shui Wai Park",
    lat: "22.454494",
    lon: "114.003128",
  },
  "K75P-U030": {
    tc_name: "天耀邨耀盛樓",
    en_name: "Yiu Shing House, Tin Yiu Estate",
    lat: "22.452347",
    lon: "114.002244",
  },
  "K75P-U040": {
    tc_name: "輕鐵天耀站",
    en_name: "LR Tin Yiu Stop",
    lat: "22.450039",
    lon: "114.002836",
    connections: {
      LR: "445",
    },
  },
  "K75P-U050": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.446917",
    lon: "114.003097",
    connections: {
      TML: "TIS",
    },
  },
  "K75P-U060": {
    tc_name: "石埗路",
    en_name: "Shek Po Road",
    lat: "22.446711",
    lon: "113.998247",
  },
  "K75P-U070": {
    tc_name: "沙洲里村",
    en_name: "Sha Chau Lei Tsuen",
    lat: "22.446108",
    lon: "113.995617",
  },
  "K75P-U080": {
    tc_name: "廈村市",
    en_name: "Ha Tsuen Shi",
    lat: "22.446186",
    lon: "113.993353",
  },
  "K75P-U090": {
    tc_name: "新屋村",
    en_name: "San Uk Tsuen",
    lat: "22.445111",
    lon: "113.992378",
  },
  "K75P-U100": {
    tc_name: "李屋村",
    en_name: "Lee Uk Tsuen",
    lat: "22.443717",
    lon: "113.991383",
  },
  "K75P-U110": {
    tc_name: "新生村",
    en_name: "San Sang Tsuen",
    lat: "22.440183",
    lon: "113.991708",
  },
  "K75P-U120": {
    tc_name: "新李屋村",
    en_name: "San Lee Uk Tsuen",
    lat: "22.436125",
    lon: "113.992242",
  },
  "K75P-U130": {
    tc_name: "田心",
    en_name: "Tin Sam",
    lat: "22.433431",
    lon: "113.992694",
  },
  "K75P-U140": {
    tc_name: "鄉事委員會",
    en_name: "Rural Committee",
    lat: "22.431597",
    lon: "113.992822",
  },
  "K75P-D010": {
    tc_name: "輕鐵洪水橋站",
    en_name: "LR Hung Shui Kiu Stop",
    lat: "22.433889",
    lon: "113.997633",
    connections: {
      LR: "380",
    },
  },
  "K75P-D020": {
    tc_name: "洪水橋巴士廠",
    en_name: "Hung Shui Kiu Bus Depot",
    lat: "22.436081",
    lon: "113.99985",
  },
  "K75P-D030": {
    tc_name: "洪福邨",
    en_name: "Hung Fuk Estate",
    lat: "22.437436",
    lon: "113.999028",
  },
  "K75P-D040": {
    tc_name: "石埗村",
    en_name: "Shek Po Tsuen",
    lat: "22.440381",
    lon: "113.998406",
  },
  "K75P-D050": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.446897",
    lon: "114.002789",
    connections: {
      TML: "TIS",
    },
  },
  "K75P-D060": {
    tc_name: "天水圍警署",
    en_name: "Tin Shui Wai Police Station",
    lat: "22.449461",
    lon: "114.002956",
    connections: {
      LR: "445",
    },
  },
  "K75P-D070": {
    tc_name: "賞湖居",
    en_name: "Sherwood Court",
    lat: "22.452539",
    lon: "114.002228",
  },
  "K75P-D080": {
    tc_name: "天水圍公園",
    en_name: "Tin Shui Wai Park",
    lat: "22.454522",
    lon: "114.002736",
  },
  "K75P-U011": {
    tc_name: "天瑞",
    en_name: "Tin Shui",
    lat: "22.455356",
    lon: "113.998975",
    connections: {
      LR: "460",
    },
  },
  //Route K76
  "K76-U010": {
    tc_name: "天恆",
    en_name: "Tin Heng",
    lat: "22.469006",
    lon: "113.999661",
  },
  "K76-U020": {
    tc_name: "天逸邨逸潭樓",
    en_name: "Yat Tam House, Tin Yat Estate",
    lat: "22.468178",
    lon: "113.999383",
    connections: {
      LR: "550",
    },
  },
  "K76-U030": {
    tc_name: "天富苑欣富閣",
    en_name: "Yan Fu House, Tin Fu Court",
    lat: "22.464353",
    lon: "113.997442",
    connections: {
      LR: "480",
    },
  },
  "K76-U040": {
    tc_name: "天盛苑 (港鐵天水圍站)",
    en_name: "Tin Shing Court (MTR Tin Shui Wai Station)",
    lat: "22.446864",
    lon: "114.002819",
    connections: {
      TML: "TIS",
    },
  },
  "K76-U050": {
    tc_name: "天水圍站 (港鐵天水圍站)",
    en_name: "Tin Shui Wai Station (MTR Tin Shui Wai Station)",
    lat: "22.446556",
    lon: "114.003731",
    connections: {
      TML: "TIS",
    },
  },
  "K76-D010": {
    tc_name: "天水圍站 (港鐵天水圍站)",
    en_name: "Tin Shui Wai Station (MTR Tin Shui Wai Station)",
    lat: "22.446556",
    lon: "114.003731",
    connections: {
      TML: "TIS",
    },
  },
  "K76-D020": {
    tc_name: "天恩邨",
    en_name: "Tin Yan Estate",
    lat: "22.464592",
    lon: "113.99725",
    connections: {
      LR: "468",
    },
  },
  "K76-D030": {
    tc_name: "天澤邨",
    en_name: "Tin Chak Estate",
    lat: "22.468061",
    lon: "113.999058",
    connections: {
      LR: "550",
    },
  },
  "K76-D040": {
    tc_name: "天恆",
    en_name: "Tin Heng",
    lat: "22.469006",
    lon: "113.999661",
  },
};

const MTRBus_Dict = { common, buses, route, stops, dest };

export default MTRBus_Dict;
